import { GraphQLClient } from 'graphql-request';
import { print } from 'graphql';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * A date string, such as 2007-12-03 (YYYY-MM-DD), compliant with ISO 8601 standard
   * for representation of dates using the Gregorian calendar.
   */
  Date: any;
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * date-timeformat outlined in section 5.6 of the RFC 3339 profile of the ISO 8601
   * standard for representationof dates and times using the Gregorian calendar.
   */
  DateTime: any;
  Hex: any;
  /** Raw JSON value */
  Json: any;
  /**
   * The Long scalar type represents non-fractional signed whole numeric values. Long
   * can represent values between -(2^63) and 2^63 - 1.
   */
  Long: any;
  RGBAHue: any;
  RGBATransparency: any;
  /** Slate-compatible RichText AST */
  RichTextAST: any;
};





export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int'];
};

/** Asset system model */
export type Asset = Node & {
  __typename?: 'Asset';
  /** System stage field */
  stage: Stage;
  /** System Locale field */
  locale: Locale;
  /** Get the other localizations for this document */
  localizations: Array<Asset>;
  /** Get the document in other stages */
  documentInStages: Array<Asset>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  /** The file handle */
  handle: Scalars['String'];
  /** The file name */
  fileName: Scalars['String'];
  /** The height of the file */
  height?: Maybe<Scalars['Float']>;
  /** The file width */
  width?: Maybe<Scalars['Float']>;
  /** The file size */
  size?: Maybe<Scalars['Float']>;
  /** The mime type of the file */
  mimeType?: Maybe<Scalars['String']>;
  authorAvatar: Array<Author>;
  blogPostCoverImage: Array<BlogPost>;
  blogPostThumbnail: Array<BlogPost>;
  stateCoverImage: Array<State>;
  cityCoverImage: Array<City>;
  cityThumbnail: Array<City>;
  providerPhoto: Array<Provider>;
  stateMapImage: Array<State>;
  cityMapImage: Array<City>;
  blogParentImage: Array<BlogParent>;
  joinSproutTherapyHomePageHeadingSectionImage: Array<JoinSproutTherapyHomePage>;
  /** List of Asset versions */
  history: Array<Version>;
  /** Get the url for the asset with provided transformations applied. */
  url: Scalars['String'];
};


/** Asset system model */
export type AssetLocalizationsArgs = {
  locales?: Array<Locale>;
  includeCurrent?: Scalars['Boolean'];
};


/** Asset system model */
export type AssetDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


/** Asset system model */
export type AssetCreatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetUpdatedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetPublishedAtArgs = {
  variation?: SystemDateTimeFieldVariation;
};


/** Asset system model */
export type AssetPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetAuthorAvatarArgs = {
  where?: Maybe<AuthorWhereInput>;
  orderBy?: Maybe<AuthorOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetBlogPostCoverImageArgs = {
  where?: Maybe<BlogPostWhereInput>;
  orderBy?: Maybe<BlogPostOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetBlogPostThumbnailArgs = {
  where?: Maybe<BlogPostWhereInput>;
  orderBy?: Maybe<BlogPostOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetStateCoverImageArgs = {
  where?: Maybe<StateWhereInput>;
  orderBy?: Maybe<StateOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetCityCoverImageArgs = {
  where?: Maybe<CityWhereInput>;
  orderBy?: Maybe<CityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetCityThumbnailArgs = {
  where?: Maybe<CityWhereInput>;
  orderBy?: Maybe<CityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetProviderPhotoArgs = {
  where?: Maybe<ProviderWhereInput>;
  orderBy?: Maybe<ProviderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetStateMapImageArgs = {
  where?: Maybe<StateWhereInput>;
  orderBy?: Maybe<StateOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetCityMapImageArgs = {
  where?: Maybe<CityWhereInput>;
  orderBy?: Maybe<CityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetBlogParentImageArgs = {
  where?: Maybe<BlogParentWhereInput>;
  orderBy?: Maybe<BlogParentOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetJoinSproutTherapyHomePageHeadingSectionImageArgs = {
  where?: Maybe<JoinSproutTherapyHomePageWhereInput>;
  orderBy?: Maybe<JoinSproutTherapyHomePageOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** Asset system model */
export type AssetHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};


/** Asset system model */
export type AssetUrlArgs = {
  transformation?: Maybe<AssetTransformationInput>;
};

export type AssetConnectInput = {
  /** Document to connect */
  where: AssetWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type AssetConnection = {
  __typename?: 'AssetConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<AssetEdge>;
  aggregate: Aggregate;
};

export type AssetCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  handle: Scalars['String'];
  fileName: Scalars['String'];
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  authorAvatar?: Maybe<AuthorCreateManyInlineInput>;
  blogPostCoverImage?: Maybe<BlogPostCreateManyInlineInput>;
  blogPostThumbnail?: Maybe<BlogPostCreateManyInlineInput>;
  stateCoverImage?: Maybe<StateCreateManyInlineInput>;
  cityCoverImage?: Maybe<CityCreateManyInlineInput>;
  cityThumbnail?: Maybe<CityCreateManyInlineInput>;
  providerPhoto?: Maybe<ProviderCreateManyInlineInput>;
  stateMapImage?: Maybe<StateCreateManyInlineInput>;
  cityMapImage?: Maybe<CityCreateManyInlineInput>;
  blogParentImage?: Maybe<BlogParentCreateManyInlineInput>;
  joinSproutTherapyHomePageHeadingSectionImage?: Maybe<JoinSproutTherapyHomePageCreateManyInlineInput>;
  /** Inline mutations for managing document localizations excluding the default locale */
  localizations?: Maybe<AssetCreateLocalizationsInput>;
};

export type AssetCreateLocalizationDataInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  handle: Scalars['String'];
  fileName: Scalars['String'];
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
};

export type AssetCreateLocalizationInput = {
  /** Localization input */
  data: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetCreateLocalizationsInput = {
  /** Create localizations for the newly-created document */
  create?: Maybe<Array<AssetCreateLocalizationInput>>;
};

export type AssetCreateManyInlineInput = {
  /** Create and connect multiple existing Asset documents */
  create?: Maybe<Array<AssetCreateInput>>;
  /** Connect multiple existing Asset documents */
  connect?: Maybe<Array<AssetWhereUniqueInput>>;
};

export type AssetCreateOneInlineInput = {
  /** Create and connect one Asset document */
  create?: Maybe<AssetCreateInput>;
  /** Connect one existing Asset document */
  connect?: Maybe<AssetWhereUniqueInput>;
};

/** An edge in a connection. */
export type AssetEdge = {
  __typename?: 'AssetEdge';
  /** The item at the end of the edge. */
  node: Asset;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type AssetManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<AssetWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  authorAvatar_every?: Maybe<AuthorWhereInput>;
  authorAvatar_some?: Maybe<AuthorWhereInput>;
  authorAvatar_none?: Maybe<AuthorWhereInput>;
  blogPostCoverImage_every?: Maybe<BlogPostWhereInput>;
  blogPostCoverImage_some?: Maybe<BlogPostWhereInput>;
  blogPostCoverImage_none?: Maybe<BlogPostWhereInput>;
  blogPostThumbnail_every?: Maybe<BlogPostWhereInput>;
  blogPostThumbnail_some?: Maybe<BlogPostWhereInput>;
  blogPostThumbnail_none?: Maybe<BlogPostWhereInput>;
  stateCoverImage_every?: Maybe<StateWhereInput>;
  stateCoverImage_some?: Maybe<StateWhereInput>;
  stateCoverImage_none?: Maybe<StateWhereInput>;
  cityCoverImage_every?: Maybe<CityWhereInput>;
  cityCoverImage_some?: Maybe<CityWhereInput>;
  cityCoverImage_none?: Maybe<CityWhereInput>;
  cityThumbnail_every?: Maybe<CityWhereInput>;
  cityThumbnail_some?: Maybe<CityWhereInput>;
  cityThumbnail_none?: Maybe<CityWhereInput>;
  providerPhoto_every?: Maybe<ProviderWhereInput>;
  providerPhoto_some?: Maybe<ProviderWhereInput>;
  providerPhoto_none?: Maybe<ProviderWhereInput>;
  stateMapImage_every?: Maybe<StateWhereInput>;
  stateMapImage_some?: Maybe<StateWhereInput>;
  stateMapImage_none?: Maybe<StateWhereInput>;
  cityMapImage_every?: Maybe<CityWhereInput>;
  cityMapImage_some?: Maybe<CityWhereInput>;
  cityMapImage_none?: Maybe<CityWhereInput>;
  blogParentImage_every?: Maybe<BlogParentWhereInput>;
  blogParentImage_some?: Maybe<BlogParentWhereInput>;
  blogParentImage_none?: Maybe<BlogParentWhereInput>;
  joinSproutTherapyHomePageHeadingSectionImage_every?: Maybe<JoinSproutTherapyHomePageWhereInput>;
  joinSproutTherapyHomePageHeadingSectionImage_some?: Maybe<JoinSproutTherapyHomePageWhereInput>;
  joinSproutTherapyHomePageHeadingSectionImage_none?: Maybe<JoinSproutTherapyHomePageWhereInput>;
};

export enum AssetOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  HandleAsc = 'handle_ASC',
  HandleDesc = 'handle_DESC',
  FileNameAsc = 'fileName_ASC',
  FileNameDesc = 'fileName_DESC',
  HeightAsc = 'height_ASC',
  HeightDesc = 'height_DESC',
  WidthAsc = 'width_ASC',
  WidthDesc = 'width_DESC',
  SizeAsc = 'size_ASC',
  SizeDesc = 'size_DESC',
  MimeTypeAsc = 'mimeType_ASC',
  MimeTypeDesc = 'mimeType_DESC'
}

/** Transformations for Assets */
export type AssetTransformationInput = {
  image?: Maybe<ImageTransformationInput>;
  document?: Maybe<DocumentTransformationInput>;
  /** Pass true if you want to validate the passed transformation parameters */
  validateOptions?: Maybe<Scalars['Boolean']>;
};

export type AssetUpdateInput = {
  handle?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  authorAvatar?: Maybe<AuthorUpdateManyInlineInput>;
  blogPostCoverImage?: Maybe<BlogPostUpdateManyInlineInput>;
  blogPostThumbnail?: Maybe<BlogPostUpdateManyInlineInput>;
  stateCoverImage?: Maybe<StateUpdateManyInlineInput>;
  cityCoverImage?: Maybe<CityUpdateManyInlineInput>;
  cityThumbnail?: Maybe<CityUpdateManyInlineInput>;
  providerPhoto?: Maybe<ProviderUpdateManyInlineInput>;
  stateMapImage?: Maybe<StateUpdateManyInlineInput>;
  cityMapImage?: Maybe<CityUpdateManyInlineInput>;
  blogParentImage?: Maybe<BlogParentUpdateManyInlineInput>;
  joinSproutTherapyHomePageHeadingSectionImage?: Maybe<JoinSproutTherapyHomePageUpdateManyInlineInput>;
  /** Manage document localizations */
  localizations?: Maybe<AssetUpdateLocalizationsInput>;
};

export type AssetUpdateLocalizationDataInput = {
  handle?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
};

export type AssetUpdateLocalizationInput = {
  data: AssetUpdateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateLocalizationsInput = {
  /** Localizations to create */
  create?: Maybe<Array<AssetCreateLocalizationInput>>;
  /** Localizations to update */
  update?: Maybe<Array<AssetUpdateLocalizationInput>>;
  upsert?: Maybe<Array<AssetUpsertLocalizationInput>>;
  /** Localizations to delete */
  delete?: Maybe<Array<Locale>>;
};

export type AssetUpdateManyInlineInput = {
  /** Create and connect multiple Asset documents */
  create?: Maybe<Array<AssetCreateInput>>;
  /** Connect multiple existing Asset documents */
  connect?: Maybe<Array<AssetConnectInput>>;
  /** Override currently-connected documents with multiple existing Asset documents */
  set?: Maybe<Array<AssetWhereUniqueInput>>;
  /** Update multiple Asset documents */
  update?: Maybe<Array<AssetUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Asset documents */
  upsert?: Maybe<Array<AssetUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple Asset documents */
  disconnect?: Maybe<Array<AssetWhereUniqueInput>>;
  /** Delete multiple Asset documents */
  delete?: Maybe<Array<AssetWhereUniqueInput>>;
};

export type AssetUpdateManyInput = {
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  /** Optional updates to localizations */
  localizations?: Maybe<AssetUpdateManyLocalizationsInput>;
};

export type AssetUpdateManyLocalizationDataInput = {
  fileName?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
};

export type AssetUpdateManyLocalizationInput = {
  data: AssetUpdateManyLocalizationDataInput;
  locale: Locale;
};

export type AssetUpdateManyLocalizationsInput = {
  /** Localizations to update */
  update?: Maybe<Array<AssetUpdateManyLocalizationInput>>;
};

export type AssetUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: AssetWhereInput;
  /** Update many input */
  data: AssetUpdateManyInput;
};

export type AssetUpdateOneInlineInput = {
  /** Create and connect one Asset document */
  create?: Maybe<AssetCreateInput>;
  /** Update single Asset document */
  update?: Maybe<AssetUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Asset document */
  upsert?: Maybe<AssetUpsertWithNestedWhereUniqueInput>;
  /** Connect existing Asset document */
  connect?: Maybe<AssetWhereUniqueInput>;
  /** Disconnect currently connected Asset document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected Asset document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type AssetUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: AssetWhereUniqueInput;
  /** Document to update */
  data: AssetUpdateInput;
};

export type AssetUpsertInput = {
  /** Create document if it didn't exist */
  create: AssetCreateInput;
  /** Update document if it exists */
  update: AssetUpdateInput;
};

export type AssetUpsertLocalizationInput = {
  update: AssetUpdateLocalizationDataInput;
  create: AssetCreateLocalizationDataInput;
  locale: Locale;
};

export type AssetUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: AssetWhereUniqueInput;
  /** Upsert data */
  data: AssetUpsertInput;
};

/** Identifies documents */
export type AssetWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<AssetWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<AssetWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<AssetWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  handle?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  handle_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  handle_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  handle_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  handle_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  handle_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  handle_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  handle_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  handle_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  handle_not_ends_with?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  fileName_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  fileName_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  fileName_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  fileName_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  fileName_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  fileName_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  fileName_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  fileName_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  fileName_not_ends_with?: Maybe<Scalars['String']>;
  height?: Maybe<Scalars['Float']>;
  /** All values that are not equal to given value. */
  height_not?: Maybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  height_in?: Maybe<Array<Scalars['Float']>>;
  /** All values that are not contained in given list. */
  height_not_in?: Maybe<Array<Scalars['Float']>>;
  /** All values less than the given value. */
  height_lt?: Maybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  height_lte?: Maybe<Scalars['Float']>;
  /** All values greater than the given value. */
  height_gt?: Maybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  height_gte?: Maybe<Scalars['Float']>;
  width?: Maybe<Scalars['Float']>;
  /** All values that are not equal to given value. */
  width_not?: Maybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  width_in?: Maybe<Array<Scalars['Float']>>;
  /** All values that are not contained in given list. */
  width_not_in?: Maybe<Array<Scalars['Float']>>;
  /** All values less than the given value. */
  width_lt?: Maybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  width_lte?: Maybe<Scalars['Float']>;
  /** All values greater than the given value. */
  width_gt?: Maybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  width_gte?: Maybe<Scalars['Float']>;
  size?: Maybe<Scalars['Float']>;
  /** All values that are not equal to given value. */
  size_not?: Maybe<Scalars['Float']>;
  /** All values that are contained in given list. */
  size_in?: Maybe<Array<Scalars['Float']>>;
  /** All values that are not contained in given list. */
  size_not_in?: Maybe<Array<Scalars['Float']>>;
  /** All values less than the given value. */
  size_lt?: Maybe<Scalars['Float']>;
  /** All values less than or equal the given value. */
  size_lte?: Maybe<Scalars['Float']>;
  /** All values greater than the given value. */
  size_gt?: Maybe<Scalars['Float']>;
  /** All values greater than or equal the given value. */
  size_gte?: Maybe<Scalars['Float']>;
  mimeType?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  mimeType_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  mimeType_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  mimeType_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  mimeType_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  mimeType_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  mimeType_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  mimeType_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  mimeType_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  mimeType_not_ends_with?: Maybe<Scalars['String']>;
  authorAvatar_every?: Maybe<AuthorWhereInput>;
  authorAvatar_some?: Maybe<AuthorWhereInput>;
  authorAvatar_none?: Maybe<AuthorWhereInput>;
  blogPostCoverImage_every?: Maybe<BlogPostWhereInput>;
  blogPostCoverImage_some?: Maybe<BlogPostWhereInput>;
  blogPostCoverImage_none?: Maybe<BlogPostWhereInput>;
  blogPostThumbnail_every?: Maybe<BlogPostWhereInput>;
  blogPostThumbnail_some?: Maybe<BlogPostWhereInput>;
  blogPostThumbnail_none?: Maybe<BlogPostWhereInput>;
  stateCoverImage_every?: Maybe<StateWhereInput>;
  stateCoverImage_some?: Maybe<StateWhereInput>;
  stateCoverImage_none?: Maybe<StateWhereInput>;
  cityCoverImage_every?: Maybe<CityWhereInput>;
  cityCoverImage_some?: Maybe<CityWhereInput>;
  cityCoverImage_none?: Maybe<CityWhereInput>;
  cityThumbnail_every?: Maybe<CityWhereInput>;
  cityThumbnail_some?: Maybe<CityWhereInput>;
  cityThumbnail_none?: Maybe<CityWhereInput>;
  providerPhoto_every?: Maybe<ProviderWhereInput>;
  providerPhoto_some?: Maybe<ProviderWhereInput>;
  providerPhoto_none?: Maybe<ProviderWhereInput>;
  stateMapImage_every?: Maybe<StateWhereInput>;
  stateMapImage_some?: Maybe<StateWhereInput>;
  stateMapImage_none?: Maybe<StateWhereInput>;
  cityMapImage_every?: Maybe<CityWhereInput>;
  cityMapImage_some?: Maybe<CityWhereInput>;
  cityMapImage_none?: Maybe<CityWhereInput>;
  blogParentImage_every?: Maybe<BlogParentWhereInput>;
  blogParentImage_some?: Maybe<BlogParentWhereInput>;
  blogParentImage_none?: Maybe<BlogParentWhereInput>;
  joinSproutTherapyHomePageHeadingSectionImage_every?: Maybe<JoinSproutTherapyHomePageWhereInput>;
  joinSproutTherapyHomePageHeadingSectionImage_some?: Maybe<JoinSproutTherapyHomePageWhereInput>;
  joinSproutTherapyHomePageHeadingSectionImage_none?: Maybe<JoinSproutTherapyHomePageWhereInput>;
};

/** References Asset record uniquely */
export type AssetWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Author = Node & {
  __typename?: 'Author';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<Author>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  name?: Maybe<Scalars['String']>;
  avatar?: Maybe<Asset>;
  extraInfo?: Maybe<Scalars['String']>;
  blogPosts: Array<BlogPost>;
  /** List of Author versions */
  history: Array<Version>;
};


export type AuthorDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type AuthorCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type AuthorUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type AuthorPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type AuthorAvatarArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type AuthorBlogPostsArgs = {
  where?: Maybe<BlogPostWhereInput>;
  orderBy?: Maybe<BlogPostOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type AuthorHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type AuthorConnectInput = {
  /** Document to connect */
  where: AuthorWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type AuthorConnection = {
  __typename?: 'AuthorConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<AuthorEdge>;
  aggregate: Aggregate;
};

export type AuthorCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  avatar?: Maybe<AssetCreateOneInlineInput>;
  extraInfo?: Maybe<Scalars['String']>;
  blogPosts?: Maybe<BlogPostCreateManyInlineInput>;
};

export type AuthorCreateManyInlineInput = {
  /** Create and connect multiple existing Author documents */
  create?: Maybe<Array<AuthorCreateInput>>;
  /** Connect multiple existing Author documents */
  connect?: Maybe<Array<AuthorWhereUniqueInput>>;
};

export type AuthorCreateOneInlineInput = {
  /** Create and connect one Author document */
  create?: Maybe<AuthorCreateInput>;
  /** Connect one existing Author document */
  connect?: Maybe<AuthorWhereUniqueInput>;
};

/** An edge in a connection. */
export type AuthorEdge = {
  __typename?: 'AuthorEdge';
  /** The item at the end of the edge. */
  node: Author;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type AuthorManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<AuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<AuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<AuthorWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  avatar?: Maybe<AssetWhereInput>;
  extraInfo?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  extraInfo_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  extraInfo_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  extraInfo_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  extraInfo_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  extraInfo_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  extraInfo_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  extraInfo_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  extraInfo_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  extraInfo_not_ends_with?: Maybe<Scalars['String']>;
  blogPosts_every?: Maybe<BlogPostWhereInput>;
  blogPosts_some?: Maybe<BlogPostWhereInput>;
  blogPosts_none?: Maybe<BlogPostWhereInput>;
};

export enum AuthorOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  ExtraInfoAsc = 'extraInfo_ASC',
  ExtraInfoDesc = 'extraInfo_DESC'
}

export type AuthorUpdateInput = {
  name?: Maybe<Scalars['String']>;
  avatar?: Maybe<AssetUpdateOneInlineInput>;
  extraInfo?: Maybe<Scalars['String']>;
  blogPosts?: Maybe<BlogPostUpdateManyInlineInput>;
};

export type AuthorUpdateManyInlineInput = {
  /** Create and connect multiple Author documents */
  create?: Maybe<Array<AuthorCreateInput>>;
  /** Connect multiple existing Author documents */
  connect?: Maybe<Array<AuthorConnectInput>>;
  /** Override currently-connected documents with multiple existing Author documents */
  set?: Maybe<Array<AuthorWhereUniqueInput>>;
  /** Update multiple Author documents */
  update?: Maybe<Array<AuthorUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Author documents */
  upsert?: Maybe<Array<AuthorUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple Author documents */
  disconnect?: Maybe<Array<AuthorWhereUniqueInput>>;
  /** Delete multiple Author documents */
  delete?: Maybe<Array<AuthorWhereUniqueInput>>;
};

export type AuthorUpdateManyInput = {
  name?: Maybe<Scalars['String']>;
  extraInfo?: Maybe<Scalars['String']>;
};

export type AuthorUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: AuthorWhereInput;
  /** Update many input */
  data: AuthorUpdateManyInput;
};

export type AuthorUpdateOneInlineInput = {
  /** Create and connect one Author document */
  create?: Maybe<AuthorCreateInput>;
  /** Update single Author document */
  update?: Maybe<AuthorUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Author document */
  upsert?: Maybe<AuthorUpsertWithNestedWhereUniqueInput>;
  /** Connect existing Author document */
  connect?: Maybe<AuthorWhereUniqueInput>;
  /** Disconnect currently connected Author document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected Author document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type AuthorUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: AuthorWhereUniqueInput;
  /** Document to update */
  data: AuthorUpdateInput;
};

export type AuthorUpsertInput = {
  /** Create document if it didn't exist */
  create: AuthorCreateInput;
  /** Update document if it exists */
  update: AuthorUpdateInput;
};

export type AuthorUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: AuthorWhereUniqueInput;
  /** Upsert data */
  data: AuthorUpsertInput;
};

/** Identifies documents */
export type AuthorWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<AuthorWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<AuthorWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<AuthorWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  avatar?: Maybe<AssetWhereInput>;
  extraInfo?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  extraInfo_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  extraInfo_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  extraInfo_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  extraInfo_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  extraInfo_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  extraInfo_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  extraInfo_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  extraInfo_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  extraInfo_not_ends_with?: Maybe<Scalars['String']>;
  blogPosts_every?: Maybe<BlogPostWhereInput>;
  blogPosts_some?: Maybe<BlogPostWhereInput>;
  blogPosts_none?: Maybe<BlogPostWhereInput>;
};

/** References Author record uniquely */
export type AuthorWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type BatchPayload = {
  __typename?: 'BatchPayload';
  /** The number of nodes that have been affected by the Batch operation. */
  count: Scalars['Long'];
};

/** This is the parent concept for each of the content pieces on the Sprout Website */
export type BlogParent = Node & {
  __typename?: 'BlogParent';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<BlogParent>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  parentname: Scalars['String'];
  parentslug: Scalars['String'];
  /** Use -1 to hide from navbar */
  navbarOrder?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<Asset>;
  blogPost: Array<BlogPost>;
  /** List of BlogParent versions */
  history: Array<Version>;
};


/** This is the parent concept for each of the content pieces on the Sprout Website */
export type BlogParentDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


/** This is the parent concept for each of the content pieces on the Sprout Website */
export type BlogParentCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** This is the parent concept for each of the content pieces on the Sprout Website */
export type BlogParentUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** This is the parent concept for each of the content pieces on the Sprout Website */
export type BlogParentPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** This is the parent concept for each of the content pieces on the Sprout Website */
export type BlogParentImageArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** This is the parent concept for each of the content pieces on the Sprout Website */
export type BlogParentBlogPostArgs = {
  where?: Maybe<BlogPostWhereInput>;
  orderBy?: Maybe<BlogPostOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


/** This is the parent concept for each of the content pieces on the Sprout Website */
export type BlogParentHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type BlogParentConnectInput = {
  /** Document to connect */
  where: BlogParentWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type BlogParentConnection = {
  __typename?: 'BlogParentConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<BlogParentEdge>;
  aggregate: Aggregate;
};

export type BlogParentCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  parentname: Scalars['String'];
  parentslug: Scalars['String'];
  navbarOrder?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<AssetCreateOneInlineInput>;
  blogPost?: Maybe<BlogPostCreateManyInlineInput>;
};

export type BlogParentCreateManyInlineInput = {
  /** Create and connect multiple existing BlogParent documents */
  create?: Maybe<Array<BlogParentCreateInput>>;
  /** Connect multiple existing BlogParent documents */
  connect?: Maybe<Array<BlogParentWhereUniqueInput>>;
};

export type BlogParentCreateOneInlineInput = {
  /** Create and connect one BlogParent document */
  create?: Maybe<BlogParentCreateInput>;
  /** Connect one existing BlogParent document */
  connect?: Maybe<BlogParentWhereUniqueInput>;
};

/** An edge in a connection. */
export type BlogParentEdge = {
  __typename?: 'BlogParentEdge';
  /** The item at the end of the edge. */
  node: BlogParent;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type BlogParentManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<BlogParentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<BlogParentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<BlogParentWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  parentname?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  parentname_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  parentname_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  parentname_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  parentname_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  parentname_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  parentname_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  parentname_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  parentname_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  parentname_not_ends_with?: Maybe<Scalars['String']>;
  parentslug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  parentslug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  parentslug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  parentslug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  parentslug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  parentslug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  parentslug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  parentslug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  parentslug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  parentslug_not_ends_with?: Maybe<Scalars['String']>;
  navbarOrder?: Maybe<Scalars['Int']>;
  /** All values that are not equal to given value. */
  navbarOrder_not?: Maybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  navbarOrder_in?: Maybe<Array<Scalars['Int']>>;
  /** All values that are not contained in given list. */
  navbarOrder_not_in?: Maybe<Array<Scalars['Int']>>;
  /** All values less than the given value. */
  navbarOrder_lt?: Maybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  navbarOrder_lte?: Maybe<Scalars['Int']>;
  /** All values greater than the given value. */
  navbarOrder_gt?: Maybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  navbarOrder_gte?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  headline_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  headline_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  headline_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  headline_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  headline_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  headline_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  headline_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  description_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  description_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  description_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  description_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: Maybe<Scalars['String']>;
  image?: Maybe<AssetWhereInput>;
  blogPost_every?: Maybe<BlogPostWhereInput>;
  blogPost_some?: Maybe<BlogPostWhereInput>;
  blogPost_none?: Maybe<BlogPostWhereInput>;
};

export enum BlogParentOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  ParentnameAsc = 'parentname_ASC',
  ParentnameDesc = 'parentname_DESC',
  ParentslugAsc = 'parentslug_ASC',
  ParentslugDesc = 'parentslug_DESC',
  NavbarOrderAsc = 'navbarOrder_ASC',
  NavbarOrderDesc = 'navbarOrder_DESC',
  HeadlineAsc = 'headline_ASC',
  HeadlineDesc = 'headline_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC'
}

export type BlogParentUpdateInput = {
  parentname?: Maybe<Scalars['String']>;
  parentslug?: Maybe<Scalars['String']>;
  navbarOrder?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  image?: Maybe<AssetUpdateOneInlineInput>;
  blogPost?: Maybe<BlogPostUpdateManyInlineInput>;
};

export type BlogParentUpdateManyInlineInput = {
  /** Create and connect multiple BlogParent documents */
  create?: Maybe<Array<BlogParentCreateInput>>;
  /** Connect multiple existing BlogParent documents */
  connect?: Maybe<Array<BlogParentConnectInput>>;
  /** Override currently-connected documents with multiple existing BlogParent documents */
  set?: Maybe<Array<BlogParentWhereUniqueInput>>;
  /** Update multiple BlogParent documents */
  update?: Maybe<Array<BlogParentUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BlogParent documents */
  upsert?: Maybe<Array<BlogParentUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple BlogParent documents */
  disconnect?: Maybe<Array<BlogParentWhereUniqueInput>>;
  /** Delete multiple BlogParent documents */
  delete?: Maybe<Array<BlogParentWhereUniqueInput>>;
};

export type BlogParentUpdateManyInput = {
  navbarOrder?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type BlogParentUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: BlogParentWhereInput;
  /** Update many input */
  data: BlogParentUpdateManyInput;
};

export type BlogParentUpdateOneInlineInput = {
  /** Create and connect one BlogParent document */
  create?: Maybe<BlogParentCreateInput>;
  /** Update single BlogParent document */
  update?: Maybe<BlogParentUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BlogParent document */
  upsert?: Maybe<BlogParentUpsertWithNestedWhereUniqueInput>;
  /** Connect existing BlogParent document */
  connect?: Maybe<BlogParentWhereUniqueInput>;
  /** Disconnect currently connected BlogParent document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected BlogParent document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type BlogParentUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: BlogParentWhereUniqueInput;
  /** Document to update */
  data: BlogParentUpdateInput;
};

export type BlogParentUpsertInput = {
  /** Create document if it didn't exist */
  create: BlogParentCreateInput;
  /** Update document if it exists */
  update: BlogParentUpdateInput;
};

export type BlogParentUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: BlogParentWhereUniqueInput;
  /** Upsert data */
  data: BlogParentUpsertInput;
};

/** Identifies documents */
export type BlogParentWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<BlogParentWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<BlogParentWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<BlogParentWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  parentname?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  parentname_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  parentname_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  parentname_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  parentname_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  parentname_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  parentname_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  parentname_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  parentname_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  parentname_not_ends_with?: Maybe<Scalars['String']>;
  parentslug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  parentslug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  parentslug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  parentslug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  parentslug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  parentslug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  parentslug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  parentslug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  parentslug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  parentslug_not_ends_with?: Maybe<Scalars['String']>;
  navbarOrder?: Maybe<Scalars['Int']>;
  /** All values that are not equal to given value. */
  navbarOrder_not?: Maybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  navbarOrder_in?: Maybe<Array<Scalars['Int']>>;
  /** All values that are not contained in given list. */
  navbarOrder_not_in?: Maybe<Array<Scalars['Int']>>;
  /** All values less than the given value. */
  navbarOrder_lt?: Maybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  navbarOrder_lte?: Maybe<Scalars['Int']>;
  /** All values greater than the given value. */
  navbarOrder_gt?: Maybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  navbarOrder_gte?: Maybe<Scalars['Int']>;
  headline?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  headline_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  headline_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  headline_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  headline_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  headline_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  headline_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  headline_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  headline_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  headline_not_ends_with?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  description_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  description_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  description_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  description_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: Maybe<Scalars['String']>;
  image?: Maybe<AssetWhereInput>;
  blogPost_every?: Maybe<BlogPostWhereInput>;
  blogPost_some?: Maybe<BlogPostWhereInput>;
  blogPost_none?: Maybe<BlogPostWhereInput>;
};

/** References BlogParent record uniquely */
export type BlogParentWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  parentname?: Maybe<Scalars['String']>;
  parentslug?: Maybe<Scalars['String']>;
};

export type BlogPost = Node & {
  __typename?: 'BlogPost';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<BlogPost>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  author?: Maybe<Author>;
  coverImage?: Maybe<Asset>;
  /** small image to display in the list of posts */
  thumbnail?: Maybe<Asset>;
  title: Scalars['String'];
  slug: Scalars['String'];
  blogparent?: Maybe<BlogParent>;
  content: RichText;
  seoData?: Maybe<SeoDataItem>;
  bookingLearnMoreAboutAutismGroup: Array<BookingLearnMoreAboutAutismGroup>;
  /** List of BlogPost versions */
  history: Array<Version>;
};


export type BlogPostDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type BlogPostCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostAuthorArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostCoverImageArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostThumbnailArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostBlogparentArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostSeoDataArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostBookingLearnMoreAboutAutismGroupArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
  orderBy?: Maybe<BookingLearnMoreAboutAutismGroupOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type BlogPostHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type BlogPostConnectInput = {
  /** Document to connect */
  where: BlogPostWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type BlogPostConnection = {
  __typename?: 'BlogPostConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<BlogPostEdge>;
  aggregate: Aggregate;
};

export type BlogPostCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  author?: Maybe<AuthorCreateOneInlineInput>;
  coverImage?: Maybe<AssetCreateOneInlineInput>;
  thumbnail?: Maybe<AssetCreateOneInlineInput>;
  title: Scalars['String'];
  slug: Scalars['String'];
  blogparent?: Maybe<BlogParentCreateOneInlineInput>;
  content: Scalars['RichTextAST'];
  seoData?: Maybe<SeoDataItemCreateOneInlineInput>;
  bookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroupCreateManyInlineInput>;
};

export type BlogPostCreateManyInlineInput = {
  /** Create and connect multiple existing BlogPost documents */
  create?: Maybe<Array<BlogPostCreateInput>>;
  /** Connect multiple existing BlogPost documents */
  connect?: Maybe<Array<BlogPostWhereUniqueInput>>;
};

export type BlogPostCreateOneInlineInput = {
  /** Create and connect one BlogPost document */
  create?: Maybe<BlogPostCreateInput>;
  /** Connect one existing BlogPost document */
  connect?: Maybe<BlogPostWhereUniqueInput>;
};

/** An edge in a connection. */
export type BlogPostEdge = {
  __typename?: 'BlogPostEdge';
  /** The item at the end of the edge. */
  node: BlogPost;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type BlogPostManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<BlogPostWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<BlogPostWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<BlogPostWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  author?: Maybe<AuthorWhereInput>;
  coverImage?: Maybe<AssetWhereInput>;
  thumbnail?: Maybe<AssetWhereInput>;
  title?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  blogparent?: Maybe<BlogParentWhereInput>;
  seoData?: Maybe<SeoDataItemWhereInput>;
  bookingLearnMoreAboutAutismGroup_every?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
  bookingLearnMoreAboutAutismGroup_some?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
  bookingLearnMoreAboutAutismGroup_none?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
};

export enum BlogPostOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC'
}

export type BlogPostUpdateInput = {
  author?: Maybe<AuthorUpdateOneInlineInput>;
  coverImage?: Maybe<AssetUpdateOneInlineInput>;
  thumbnail?: Maybe<AssetUpdateOneInlineInput>;
  title?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  blogparent?: Maybe<BlogParentUpdateOneInlineInput>;
  content?: Maybe<Scalars['RichTextAST']>;
  seoData?: Maybe<SeoDataItemUpdateOneInlineInput>;
  bookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroupUpdateManyInlineInput>;
};

export type BlogPostUpdateManyInlineInput = {
  /** Create and connect multiple BlogPost documents */
  create?: Maybe<Array<BlogPostCreateInput>>;
  /** Connect multiple existing BlogPost documents */
  connect?: Maybe<Array<BlogPostConnectInput>>;
  /** Override currently-connected documents with multiple existing BlogPost documents */
  set?: Maybe<Array<BlogPostWhereUniqueInput>>;
  /** Update multiple BlogPost documents */
  update?: Maybe<Array<BlogPostUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BlogPost documents */
  upsert?: Maybe<Array<BlogPostUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple BlogPost documents */
  disconnect?: Maybe<Array<BlogPostWhereUniqueInput>>;
  /** Delete multiple BlogPost documents */
  delete?: Maybe<Array<BlogPostWhereUniqueInput>>;
};

export type BlogPostUpdateManyInput = {
  title?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['RichTextAST']>;
};

export type BlogPostUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: BlogPostWhereInput;
  /** Update many input */
  data: BlogPostUpdateManyInput;
};

export type BlogPostUpdateOneInlineInput = {
  /** Create and connect one BlogPost document */
  create?: Maybe<BlogPostCreateInput>;
  /** Update single BlogPost document */
  update?: Maybe<BlogPostUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BlogPost document */
  upsert?: Maybe<BlogPostUpsertWithNestedWhereUniqueInput>;
  /** Connect existing BlogPost document */
  connect?: Maybe<BlogPostWhereUniqueInput>;
  /** Disconnect currently connected BlogPost document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected BlogPost document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type BlogPostUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: BlogPostWhereUniqueInput;
  /** Document to update */
  data: BlogPostUpdateInput;
};

export type BlogPostUpsertInput = {
  /** Create document if it didn't exist */
  create: BlogPostCreateInput;
  /** Update document if it exists */
  update: BlogPostUpdateInput;
};

export type BlogPostUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: BlogPostWhereUniqueInput;
  /** Upsert data */
  data: BlogPostUpsertInput;
};

/** Identifies documents */
export type BlogPostWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<BlogPostWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<BlogPostWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<BlogPostWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  author?: Maybe<AuthorWhereInput>;
  coverImage?: Maybe<AssetWhereInput>;
  thumbnail?: Maybe<AssetWhereInput>;
  title?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  blogparent?: Maybe<BlogParentWhereInput>;
  seoData?: Maybe<SeoDataItemWhereInput>;
  bookingLearnMoreAboutAutismGroup_every?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
  bookingLearnMoreAboutAutismGroup_some?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
  bookingLearnMoreAboutAutismGroup_none?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
};

/** References BlogPost record uniquely */
export type BlogPostWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
};

export type BookingLearnMoreAboutAutismGroup = Node & {
  __typename?: 'BookingLearnMoreAboutAutismGroup';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<BookingLearnMoreAboutAutismGroup>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  name: Scalars['String'];
  /** used for URL */
  slug: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  /**
   * used to sort the list of groups
   * example: 1, 2, or 3
   */
  position: Scalars['Int'];
  blogPosts: Array<BlogPost>;
  /** List of BookingLearnMoreAboutAutismGroup versions */
  history: Array<Version>;
};


export type BookingLearnMoreAboutAutismGroupDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type BookingLearnMoreAboutAutismGroupCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BookingLearnMoreAboutAutismGroupUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BookingLearnMoreAboutAutismGroupPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type BookingLearnMoreAboutAutismGroupBlogPostsArgs = {
  where?: Maybe<BlogPostWhereInput>;
  orderBy?: Maybe<BlogPostOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type BookingLearnMoreAboutAutismGroupHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type BookingLearnMoreAboutAutismGroupConnectInput = {
  /** Document to connect */
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type BookingLearnMoreAboutAutismGroupConnection = {
  __typename?: 'BookingLearnMoreAboutAutismGroupConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<BookingLearnMoreAboutAutismGroupEdge>;
  aggregate: Aggregate;
};

export type BookingLearnMoreAboutAutismGroupCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  slug: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  blogPosts?: Maybe<BlogPostCreateManyInlineInput>;
};

export type BookingLearnMoreAboutAutismGroupCreateManyInlineInput = {
  /** Create and connect multiple existing BookingLearnMoreAboutAutismGroup documents */
  create?: Maybe<Array<BookingLearnMoreAboutAutismGroupCreateInput>>;
  /** Connect multiple existing BookingLearnMoreAboutAutismGroup documents */
  connect?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereUniqueInput>>;
};

export type BookingLearnMoreAboutAutismGroupCreateOneInlineInput = {
  /** Create and connect one BookingLearnMoreAboutAutismGroup document */
  create?: Maybe<BookingLearnMoreAboutAutismGroupCreateInput>;
  /** Connect one existing BookingLearnMoreAboutAutismGroup document */
  connect?: Maybe<BookingLearnMoreAboutAutismGroupWhereUniqueInput>;
};

/** An edge in a connection. */
export type BookingLearnMoreAboutAutismGroupEdge = {
  __typename?: 'BookingLearnMoreAboutAutismGroupEdge';
  /** The item at the end of the edge. */
  node: BookingLearnMoreAboutAutismGroup;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type BookingLearnMoreAboutAutismGroupManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  description_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  description_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  description_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  description_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  /** All values that are not equal to given value. */
  position_not?: Maybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  position_in?: Maybe<Array<Scalars['Int']>>;
  /** All values that are not contained in given list. */
  position_not_in?: Maybe<Array<Scalars['Int']>>;
  /** All values less than the given value. */
  position_lt?: Maybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  position_lte?: Maybe<Scalars['Int']>;
  /** All values greater than the given value. */
  position_gt?: Maybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  position_gte?: Maybe<Scalars['Int']>;
  blogPosts_every?: Maybe<BlogPostWhereInput>;
  blogPosts_some?: Maybe<BlogPostWhereInput>;
  blogPosts_none?: Maybe<BlogPostWhereInput>;
};

export enum BookingLearnMoreAboutAutismGroupOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC',
  PositionAsc = 'position_ASC',
  PositionDesc = 'position_DESC'
}

export type BookingLearnMoreAboutAutismGroupUpdateInput = {
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  blogPosts?: Maybe<BlogPostUpdateManyInlineInput>;
};

export type BookingLearnMoreAboutAutismGroupUpdateManyInlineInput = {
  /** Create and connect multiple BookingLearnMoreAboutAutismGroup documents */
  create?: Maybe<Array<BookingLearnMoreAboutAutismGroupCreateInput>>;
  /** Connect multiple existing BookingLearnMoreAboutAutismGroup documents */
  connect?: Maybe<Array<BookingLearnMoreAboutAutismGroupConnectInput>>;
  /** Override currently-connected documents with multiple existing BookingLearnMoreAboutAutismGroup documents */
  set?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereUniqueInput>>;
  /** Update multiple BookingLearnMoreAboutAutismGroup documents */
  update?: Maybe<Array<BookingLearnMoreAboutAutismGroupUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple BookingLearnMoreAboutAutismGroup documents */
  upsert?: Maybe<Array<BookingLearnMoreAboutAutismGroupUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple BookingLearnMoreAboutAutismGroup documents */
  disconnect?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereUniqueInput>>;
  /** Delete multiple BookingLearnMoreAboutAutismGroup documents */
  delete?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereUniqueInput>>;
};

export type BookingLearnMoreAboutAutismGroupUpdateManyInput = {
  description?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
};

export type BookingLearnMoreAboutAutismGroupUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: BookingLearnMoreAboutAutismGroupWhereInput;
  /** Update many input */
  data: BookingLearnMoreAboutAutismGroupUpdateManyInput;
};

export type BookingLearnMoreAboutAutismGroupUpdateOneInlineInput = {
  /** Create and connect one BookingLearnMoreAboutAutismGroup document */
  create?: Maybe<BookingLearnMoreAboutAutismGroupCreateInput>;
  /** Update single BookingLearnMoreAboutAutismGroup document */
  update?: Maybe<BookingLearnMoreAboutAutismGroupUpdateWithNestedWhereUniqueInput>;
  /** Upsert single BookingLearnMoreAboutAutismGroup document */
  upsert?: Maybe<BookingLearnMoreAboutAutismGroupUpsertWithNestedWhereUniqueInput>;
  /** Connect existing BookingLearnMoreAboutAutismGroup document */
  connect?: Maybe<BookingLearnMoreAboutAutismGroupWhereUniqueInput>;
  /** Disconnect currently connected BookingLearnMoreAboutAutismGroup document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected BookingLearnMoreAboutAutismGroup document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type BookingLearnMoreAboutAutismGroupUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
  /** Document to update */
  data: BookingLearnMoreAboutAutismGroupUpdateInput;
};

export type BookingLearnMoreAboutAutismGroupUpsertInput = {
  /** Create document if it didn't exist */
  create: BookingLearnMoreAboutAutismGroupCreateInput;
  /** Update document if it exists */
  update: BookingLearnMoreAboutAutismGroupUpdateInput;
};

export type BookingLearnMoreAboutAutismGroupUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
  /** Upsert data */
  data: BookingLearnMoreAboutAutismGroupUpsertInput;
};

/** Identifies documents */
export type BookingLearnMoreAboutAutismGroupWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<BookingLearnMoreAboutAutismGroupWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  description_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  description_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  description_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  description_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
  /** All values that are not equal to given value. */
  position_not?: Maybe<Scalars['Int']>;
  /** All values that are contained in given list. */
  position_in?: Maybe<Array<Scalars['Int']>>;
  /** All values that are not contained in given list. */
  position_not_in?: Maybe<Array<Scalars['Int']>>;
  /** All values less than the given value. */
  position_lt?: Maybe<Scalars['Int']>;
  /** All values less than or equal the given value. */
  position_lte?: Maybe<Scalars['Int']>;
  /** All values greater than the given value. */
  position_gt?: Maybe<Scalars['Int']>;
  /** All values greater than or equal the given value. */
  position_gte?: Maybe<Scalars['Int']>;
  blogPosts_every?: Maybe<BlogPostWhereInput>;
  blogPosts_some?: Maybe<BlogPostWhereInput>;
  blogPosts_none?: Maybe<BlogPostWhereInput>;
};

/** References BookingLearnMoreAboutAutismGroup record uniquely */
export type BookingLearnMoreAboutAutismGroupWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export type City = Node & {
  __typename?: 'City';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<City>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  state?: Maybe<State>;
  name: Scalars['String'];
  slug: Scalars['String'];
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  descriptionHeader?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  abaTherapyDescription?: Maybe<Scalars['String']>;
  autismDiagnosisDescription?: Maybe<Scalars['String']>;
  zipCodes: Array<Scalars['String']>;
  coverImage?: Maybe<Asset>;
  /** used for a list of cities */
  thumbnail?: Maybe<Asset>;
  clinics: Array<Clinic>;
  providers: Array<Provider>;
  mapImage?: Maybe<Asset>;
  leadProvider: Array<Provider>;
  /** List of City versions */
  history: Array<Version>;
};


export type CityDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type CityCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type CityUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type CityPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type CityStateArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type CityCoverImageArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type CityThumbnailArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type CityClinicsArgs = {
  where?: Maybe<ClinicWhereInput>;
  orderBy?: Maybe<ClinicOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type CityProvidersArgs = {
  where?: Maybe<ProviderWhereInput>;
  orderBy?: Maybe<ProviderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type CityMapImageArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type CityLeadProviderArgs = {
  where?: Maybe<ProviderWhereInput>;
  orderBy?: Maybe<ProviderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type CityHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type CityConnectInput = {
  /** Document to connect */
  where: CityWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type CityConnection = {
  __typename?: 'CityConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<CityEdge>;
  aggregate: Aggregate;
};

export type CityCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  state?: Maybe<StateCreateOneInlineInput>;
  name: Scalars['String'];
  slug: Scalars['String'];
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  descriptionHeader?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  abaTherapyDescription?: Maybe<Scalars['String']>;
  autismDiagnosisDescription?: Maybe<Scalars['String']>;
  zipCodes?: Maybe<Array<Scalars['String']>>;
  coverImage?: Maybe<AssetCreateOneInlineInput>;
  thumbnail?: Maybe<AssetCreateOneInlineInput>;
  clinics?: Maybe<ClinicCreateManyInlineInput>;
  providers?: Maybe<ProviderCreateManyInlineInput>;
  mapImage?: Maybe<AssetCreateOneInlineInput>;
  leadProvider?: Maybe<ProviderCreateManyInlineInput>;
};

export type CityCreateManyInlineInput = {
  /** Create and connect multiple existing City documents */
  create?: Maybe<Array<CityCreateInput>>;
  /** Connect multiple existing City documents */
  connect?: Maybe<Array<CityWhereUniqueInput>>;
};

export type CityCreateOneInlineInput = {
  /** Create and connect one City document */
  create?: Maybe<CityCreateInput>;
  /** Connect one existing City document */
  connect?: Maybe<CityWhereUniqueInput>;
};

/** An edge in a connection. */
export type CityEdge = {
  __typename?: 'CityEdge';
  /** The item at the end of the edge. */
  node: City;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type CityManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<CityWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<CityWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<CityWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  state?: Maybe<StateWhereInput>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  title1?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title1_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title1_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title1_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title1_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title1_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title1_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title1_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title1_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title1_not_ends_with?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title2_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title2_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title2_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title2_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title2_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title2_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title2_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title2_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title2_not_ends_with?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  about_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  about_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  about_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  about_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  about_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  about_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  about_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  about_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  about_not_ends_with?: Maybe<Scalars['String']>;
  descriptionHeader?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  descriptionHeader_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  descriptionHeader_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  descriptionHeader_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  descriptionHeader_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  descriptionHeader_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  descriptionHeader_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  descriptionHeader_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  descriptionHeader_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  descriptionHeader_not_ends_with?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  descriptionText_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  descriptionText_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  descriptionText_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  descriptionText_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  descriptionText_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  descriptionText_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  descriptionText_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  descriptionText_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  descriptionText_not_ends_with?: Maybe<Scalars['String']>;
  abaTherapyDescription?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  abaTherapyDescription_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  abaTherapyDescription_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  abaTherapyDescription_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  abaTherapyDescription_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  abaTherapyDescription_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  abaTherapyDescription_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  abaTherapyDescription_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  abaTherapyDescription_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  abaTherapyDescription_not_ends_with?: Maybe<Scalars['String']>;
  autismDiagnosisDescription?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  autismDiagnosisDescription_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  autismDiagnosisDescription_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  autismDiagnosisDescription_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  autismDiagnosisDescription_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  autismDiagnosisDescription_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  autismDiagnosisDescription_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  autismDiagnosisDescription_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  autismDiagnosisDescription_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  autismDiagnosisDescription_not_ends_with?: Maybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  zipCodes?: Maybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  zipCodes_not?: Maybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  zipCodes_contains_all?: Maybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  zipCodes_contains_some?: Maybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  zipCodes_contains_none?: Maybe<Array<Scalars['String']>>;
  coverImage?: Maybe<AssetWhereInput>;
  thumbnail?: Maybe<AssetWhereInput>;
  clinics_every?: Maybe<ClinicWhereInput>;
  clinics_some?: Maybe<ClinicWhereInput>;
  clinics_none?: Maybe<ClinicWhereInput>;
  providers_every?: Maybe<ProviderWhereInput>;
  providers_some?: Maybe<ProviderWhereInput>;
  providers_none?: Maybe<ProviderWhereInput>;
  mapImage?: Maybe<AssetWhereInput>;
  leadProvider_every?: Maybe<ProviderWhereInput>;
  leadProvider_some?: Maybe<ProviderWhereInput>;
  leadProvider_none?: Maybe<ProviderWhereInput>;
};

export enum CityOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  Title1Asc = 'title1_ASC',
  Title1Desc = 'title1_DESC',
  Title2Asc = 'title2_ASC',
  Title2Desc = 'title2_DESC',
  AboutAsc = 'about_ASC',
  AboutDesc = 'about_DESC',
  DescriptionHeaderAsc = 'descriptionHeader_ASC',
  DescriptionHeaderDesc = 'descriptionHeader_DESC',
  DescriptionTextAsc = 'descriptionText_ASC',
  DescriptionTextDesc = 'descriptionText_DESC',
  AbaTherapyDescriptionAsc = 'abaTherapyDescription_ASC',
  AbaTherapyDescriptionDesc = 'abaTherapyDescription_DESC',
  AutismDiagnosisDescriptionAsc = 'autismDiagnosisDescription_ASC',
  AutismDiagnosisDescriptionDesc = 'autismDiagnosisDescription_DESC',
  ZipCodesAsc = 'zipCodes_ASC',
  ZipCodesDesc = 'zipCodes_DESC'
}

export type CityUpdateInput = {
  state?: Maybe<StateUpdateOneInlineInput>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  descriptionHeader?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  abaTherapyDescription?: Maybe<Scalars['String']>;
  autismDiagnosisDescription?: Maybe<Scalars['String']>;
  zipCodes?: Maybe<Array<Scalars['String']>>;
  coverImage?: Maybe<AssetUpdateOneInlineInput>;
  thumbnail?: Maybe<AssetUpdateOneInlineInput>;
  clinics?: Maybe<ClinicUpdateManyInlineInput>;
  providers?: Maybe<ProviderUpdateManyInlineInput>;
  mapImage?: Maybe<AssetUpdateOneInlineInput>;
  leadProvider?: Maybe<ProviderUpdateManyInlineInput>;
};

export type CityUpdateManyInlineInput = {
  /** Create and connect multiple City documents */
  create?: Maybe<Array<CityCreateInput>>;
  /** Connect multiple existing City documents */
  connect?: Maybe<Array<CityConnectInput>>;
  /** Override currently-connected documents with multiple existing City documents */
  set?: Maybe<Array<CityWhereUniqueInput>>;
  /** Update multiple City documents */
  update?: Maybe<Array<CityUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple City documents */
  upsert?: Maybe<Array<CityUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple City documents */
  disconnect?: Maybe<Array<CityWhereUniqueInput>>;
  /** Delete multiple City documents */
  delete?: Maybe<Array<CityWhereUniqueInput>>;
};

export type CityUpdateManyInput = {
  name?: Maybe<Scalars['String']>;
  title1?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  descriptionHeader?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  abaTherapyDescription?: Maybe<Scalars['String']>;
  autismDiagnosisDescription?: Maybe<Scalars['String']>;
  zipCodes?: Maybe<Array<Scalars['String']>>;
};

export type CityUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: CityWhereInput;
  /** Update many input */
  data: CityUpdateManyInput;
};

export type CityUpdateOneInlineInput = {
  /** Create and connect one City document */
  create?: Maybe<CityCreateInput>;
  /** Update single City document */
  update?: Maybe<CityUpdateWithNestedWhereUniqueInput>;
  /** Upsert single City document */
  upsert?: Maybe<CityUpsertWithNestedWhereUniqueInput>;
  /** Connect existing City document */
  connect?: Maybe<CityWhereUniqueInput>;
  /** Disconnect currently connected City document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected City document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type CityUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: CityWhereUniqueInput;
  /** Document to update */
  data: CityUpdateInput;
};

export type CityUpsertInput = {
  /** Create document if it didn't exist */
  create: CityCreateInput;
  /** Update document if it exists */
  update: CityUpdateInput;
};

export type CityUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: CityWhereUniqueInput;
  /** Upsert data */
  data: CityUpsertInput;
};

/** Identifies documents */
export type CityWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<CityWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<CityWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<CityWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  state?: Maybe<StateWhereInput>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  title1?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title1_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title1_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title1_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title1_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title1_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title1_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title1_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title1_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title1_not_ends_with?: Maybe<Scalars['String']>;
  title2?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title2_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title2_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title2_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title2_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title2_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title2_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title2_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title2_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title2_not_ends_with?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  about_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  about_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  about_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  about_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  about_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  about_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  about_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  about_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  about_not_ends_with?: Maybe<Scalars['String']>;
  descriptionHeader?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  descriptionHeader_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  descriptionHeader_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  descriptionHeader_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  descriptionHeader_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  descriptionHeader_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  descriptionHeader_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  descriptionHeader_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  descriptionHeader_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  descriptionHeader_not_ends_with?: Maybe<Scalars['String']>;
  descriptionText?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  descriptionText_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  descriptionText_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  descriptionText_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  descriptionText_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  descriptionText_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  descriptionText_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  descriptionText_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  descriptionText_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  descriptionText_not_ends_with?: Maybe<Scalars['String']>;
  abaTherapyDescription?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  abaTherapyDescription_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  abaTherapyDescription_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  abaTherapyDescription_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  abaTherapyDescription_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  abaTherapyDescription_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  abaTherapyDescription_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  abaTherapyDescription_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  abaTherapyDescription_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  abaTherapyDescription_not_ends_with?: Maybe<Scalars['String']>;
  autismDiagnosisDescription?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  autismDiagnosisDescription_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  autismDiagnosisDescription_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  autismDiagnosisDescription_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  autismDiagnosisDescription_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  autismDiagnosisDescription_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  autismDiagnosisDescription_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  autismDiagnosisDescription_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  autismDiagnosisDescription_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  autismDiagnosisDescription_not_ends_with?: Maybe<Scalars['String']>;
  /** Matches if the field array contains *all* items provided to the filter and order does match */
  zipCodes?: Maybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contains *all* items provided to the filter or order does not match */
  zipCodes_not?: Maybe<Array<Scalars['String']>>;
  /** Matches if the field array contains *all* items provided to the filter */
  zipCodes_contains_all?: Maybe<Array<Scalars['String']>>;
  /** Matches if the field array contains at least one item provided to the filter */
  zipCodes_contains_some?: Maybe<Array<Scalars['String']>>;
  /** Matches if the field array does not contain any of the items provided to the filter */
  zipCodes_contains_none?: Maybe<Array<Scalars['String']>>;
  coverImage?: Maybe<AssetWhereInput>;
  thumbnail?: Maybe<AssetWhereInput>;
  clinics_every?: Maybe<ClinicWhereInput>;
  clinics_some?: Maybe<ClinicWhereInput>;
  clinics_none?: Maybe<ClinicWhereInput>;
  providers_every?: Maybe<ProviderWhereInput>;
  providers_some?: Maybe<ProviderWhereInput>;
  providers_none?: Maybe<ProviderWhereInput>;
  mapImage?: Maybe<AssetWhereInput>;
  leadProvider_every?: Maybe<ProviderWhereInput>;
  leadProvider_some?: Maybe<ProviderWhereInput>;
  leadProvider_none?: Maybe<ProviderWhereInput>;
};

/** References City record uniquely */
export type CityWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
};

export type Clinic = Node & {
  __typename?: 'Clinic';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<Clinic>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  title: Scalars['String'];
  address: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  city?: Maybe<City>;
  location: Location;
  /** List of Clinic versions */
  history: Array<Version>;
};


export type ClinicDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type ClinicCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ClinicUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ClinicPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ClinicCityArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ClinicHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type ClinicConnectInput = {
  /** Document to connect */
  where: ClinicWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type ClinicConnection = {
  __typename?: 'ClinicConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<ClinicEdge>;
  aggregate: Aggregate;
};

export type ClinicCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title: Scalars['String'];
  address: Scalars['String'];
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  city?: Maybe<CityCreateOneInlineInput>;
  location: LocationInput;
};

export type ClinicCreateManyInlineInput = {
  /** Create and connect multiple existing Clinic documents */
  create?: Maybe<Array<ClinicCreateInput>>;
  /** Connect multiple existing Clinic documents */
  connect?: Maybe<Array<ClinicWhereUniqueInput>>;
};

export type ClinicCreateOneInlineInput = {
  /** Create and connect one Clinic document */
  create?: Maybe<ClinicCreateInput>;
  /** Connect one existing Clinic document */
  connect?: Maybe<ClinicWhereUniqueInput>;
};

/** An edge in a connection. */
export type ClinicEdge = {
  __typename?: 'ClinicEdge';
  /** The item at the end of the edge. */
  node: Clinic;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type ClinicManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<ClinicWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<ClinicWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<ClinicWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  title?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  address_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  address_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  address_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  address_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  address_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  address_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  address_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  address_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  address_not_ends_with?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  address2_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  address2_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  address2_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  address2_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  address2_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  address2_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  address2_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  address2_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  address2_not_ends_with?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  address3_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  address3_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  address3_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  address3_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  address3_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  address3_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  address3_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  address3_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  address3_not_ends_with?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  phone_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  phone_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  phone_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  phone_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  phone_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  phone_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  phone_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  phone_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  phone_not_ends_with?: Maybe<Scalars['String']>;
  city?: Maybe<CityWhereInput>;
};

export enum ClinicOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  AddressAsc = 'address_ASC',
  AddressDesc = 'address_DESC',
  Address2Asc = 'address2_ASC',
  Address2Desc = 'address2_DESC',
  Address3Asc = 'address3_ASC',
  Address3Desc = 'address3_DESC',
  PhoneAsc = 'phone_ASC',
  PhoneDesc = 'phone_DESC'
}

export type ClinicUpdateInput = {
  title?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  city?: Maybe<CityUpdateOneInlineInput>;
  location?: Maybe<LocationInput>;
};

export type ClinicUpdateManyInlineInput = {
  /** Create and connect multiple Clinic documents */
  create?: Maybe<Array<ClinicCreateInput>>;
  /** Connect multiple existing Clinic documents */
  connect?: Maybe<Array<ClinicConnectInput>>;
  /** Override currently-connected documents with multiple existing Clinic documents */
  set?: Maybe<Array<ClinicWhereUniqueInput>>;
  /** Update multiple Clinic documents */
  update?: Maybe<Array<ClinicUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Clinic documents */
  upsert?: Maybe<Array<ClinicUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple Clinic documents */
  disconnect?: Maybe<Array<ClinicWhereUniqueInput>>;
  /** Delete multiple Clinic documents */
  delete?: Maybe<Array<ClinicWhereUniqueInput>>;
};

export type ClinicUpdateManyInput = {
  title?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  location?: Maybe<LocationInput>;
};

export type ClinicUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: ClinicWhereInput;
  /** Update many input */
  data: ClinicUpdateManyInput;
};

export type ClinicUpdateOneInlineInput = {
  /** Create and connect one Clinic document */
  create?: Maybe<ClinicCreateInput>;
  /** Update single Clinic document */
  update?: Maybe<ClinicUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Clinic document */
  upsert?: Maybe<ClinicUpsertWithNestedWhereUniqueInput>;
  /** Connect existing Clinic document */
  connect?: Maybe<ClinicWhereUniqueInput>;
  /** Disconnect currently connected Clinic document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected Clinic document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type ClinicUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: ClinicWhereUniqueInput;
  /** Document to update */
  data: ClinicUpdateInput;
};

export type ClinicUpsertInput = {
  /** Create document if it didn't exist */
  create: ClinicCreateInput;
  /** Update document if it exists */
  update: ClinicUpdateInput;
};

export type ClinicUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: ClinicWhereUniqueInput;
  /** Upsert data */
  data: ClinicUpsertInput;
};

/** Identifies documents */
export type ClinicWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<ClinicWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<ClinicWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<ClinicWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  title?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  address_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  address_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  address_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  address_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  address_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  address_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  address_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  address_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  address_not_ends_with?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  address2_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  address2_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  address2_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  address2_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  address2_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  address2_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  address2_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  address2_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  address2_not_ends_with?: Maybe<Scalars['String']>;
  address3?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  address3_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  address3_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  address3_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  address3_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  address3_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  address3_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  address3_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  address3_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  address3_not_ends_with?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  phone_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  phone_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  phone_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  phone_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  phone_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  phone_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  phone_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  phone_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  phone_not_ends_with?: Maybe<Scalars['String']>;
  city?: Maybe<CityWhereInput>;
};

/** References Clinic record uniquely */
export type ClinicWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

/** Representing a color value comprising of HEX, RGBA and css color values */
export type Color = {
  __typename?: 'Color';
  hex: Scalars['Hex'];
  rgba: Rgba;
  css: Scalars['String'];
};

/** Accepts either HEX or RGBA color value. At least one of hex or rgba value should be passed. If both are passed RGBA is used. */
export type ColorInput = {
  hex?: Maybe<Scalars['Hex']>;
  rgba?: Maybe<RgbaInput>;
};

export type ConnectPositionInput = {
  /** Connect document after specified document */
  after?: Maybe<Scalars['ID']>;
  /** Connect document before specified document */
  before?: Maybe<Scalars['ID']>;
  /** Connect document at first position */
  start?: Maybe<Scalars['Boolean']>;
  /** Connect document at last position */
  end?: Maybe<Scalars['Boolean']>;
};



export enum DocumentFileTypes {
  Jpg = 'jpg',
  Odp = 'odp',
  Ods = 'ods',
  Odt = 'odt',
  Png = 'png',
  Svg = 'svg',
  Txt = 'txt',
  Webp = 'webp',
  Docx = 'docx',
  Pdf = 'pdf',
  Html = 'html',
  Doc = 'doc',
  Xlsx = 'xlsx',
  Xls = 'xls',
  Pptx = 'pptx',
  Ppt = 'ppt'
}

export type DocumentOutputInput = {
  /**
   * Transforms a document into a desired file type.
   * See this matrix for format support:
   *
   * PDF:	jpg, odp, ods, odt, png, svg, txt, and webp
   * DOC:	docx, html, jpg, odt, pdf, png, svg, txt, and webp
   * DOCX:	doc, html, jpg, odt, pdf, png, svg, txt, and webp
   * ODT:	doc, docx, html, jpg, pdf, png, svg, txt, and webp
   * XLS:	jpg, pdf, ods, png, svg, xlsx, and webp
   * XLSX:	jpg, pdf, ods, png, svg, xls, and webp
   * ODS:	jpg, pdf, png, xls, svg, xlsx, and webp
   * PPT:	jpg, odp, pdf, png, svg, pptx, and webp
   * PPTX:	jpg, odp, pdf, png, svg, ppt, and webp
   * ODP:	jpg, pdf, png, ppt, svg, pptx, and webp
   * BMP:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * GIF:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * JPG:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * PNG:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * WEBP:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * TIFF:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * AI:	    jpg, odp, ods, odt, pdf, png, svg, and webp
   * PSD:	jpg, odp, ods, odt, pdf, png, svg, and webp
   * SVG:	jpg, odp, ods, odt, pdf, png, and webp
   * HTML:	jpg, odt, pdf, svg, txt, and webp
   * TXT:	jpg, html, odt, pdf, svg, and webp
   */
  format?: Maybe<DocumentFileTypes>;
};

/** Transformations for Documents */
export type DocumentTransformationInput = {
  /** Changes the output for the file. */
  output?: Maybe<DocumentOutputInput>;
};

export type DocumentVersion = {
  __typename?: 'DocumentVersion';
  id: Scalars['ID'];
  stage: Stage;
  revision: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  data?: Maybe<Scalars['Json']>;
};


export enum ImageFit {
  /** Resizes the image to fit within the specified parameters without distorting, cropping, or changing the aspect ratio. */
  Clip = 'clip',
  /**
   * Resizes the image to fit the specified parameters exactly by removing any
   * parts of the image that don't fit within the boundaries.
   */
  Crop = 'crop',
  /**
   * Resizes the image to fit the specified parameters exactly by scaling the image
   * to the desired size. The aspect ratio of the image is not respected and the
   * image can be distorted using this method.
   */
  Scale = 'scale',
  /**
   * Resizes the image to fit within the parameters, but as opposed to 'fit:clip'
   * will not scale the image if the image is smaller than the output size.
   */
  Max = 'max'
}

export type ImageResizeInput = {
  /** The width in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  width?: Maybe<Scalars['Int']>;
  /** The height in pixels to resize the image to. The value must be an integer from 1 to 10000. */
  height?: Maybe<Scalars['Int']>;
  /** The default value for the fit parameter is fit:clip. */
  fit?: Maybe<ImageFit>;
};

/** Transformations for Images */
export type ImageTransformationInput = {
  /** Resizes the image */
  resize?: Maybe<ImageResizeInput>;
};

export type JoinSproutTherapyHomePage = Node & {
  __typename?: 'JoinSproutTherapyHomePage';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<JoinSproutTherapyHomePage>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  headingSectionTitle?: Maybe<Scalars['String']>;
  headingSectionBtnText?: Maybe<Scalars['String']>;
  headingSectionImage?: Maybe<Asset>;
  /** List of JoinSproutTherapyHomePage versions */
  history: Array<Version>;
};


export type JoinSproutTherapyHomePageDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type JoinSproutTherapyHomePageCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type JoinSproutTherapyHomePageUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type JoinSproutTherapyHomePagePublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type JoinSproutTherapyHomePageHeadingSectionImageArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type JoinSproutTherapyHomePageHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type JoinSproutTherapyHomePageConnectInput = {
  /** Document to connect */
  where: JoinSproutTherapyHomePageWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type JoinSproutTherapyHomePageConnection = {
  __typename?: 'JoinSproutTherapyHomePageConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<JoinSproutTherapyHomePageEdge>;
  aggregate: Aggregate;
};

export type JoinSproutTherapyHomePageCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  headingSectionTitle?: Maybe<Scalars['String']>;
  headingSectionBtnText?: Maybe<Scalars['String']>;
  headingSectionImage?: Maybe<AssetCreateOneInlineInput>;
};

export type JoinSproutTherapyHomePageCreateManyInlineInput = {
  /** Create and connect multiple existing JoinSproutTherapyHomePage documents */
  create?: Maybe<Array<JoinSproutTherapyHomePageCreateInput>>;
  /** Connect multiple existing JoinSproutTherapyHomePage documents */
  connect?: Maybe<Array<JoinSproutTherapyHomePageWhereUniqueInput>>;
};

export type JoinSproutTherapyHomePageCreateOneInlineInput = {
  /** Create and connect one JoinSproutTherapyHomePage document */
  create?: Maybe<JoinSproutTherapyHomePageCreateInput>;
  /** Connect one existing JoinSproutTherapyHomePage document */
  connect?: Maybe<JoinSproutTherapyHomePageWhereUniqueInput>;
};

/** An edge in a connection. */
export type JoinSproutTherapyHomePageEdge = {
  __typename?: 'JoinSproutTherapyHomePageEdge';
  /** The item at the end of the edge. */
  node: JoinSproutTherapyHomePage;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type JoinSproutTherapyHomePageManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<JoinSproutTherapyHomePageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<JoinSproutTherapyHomePageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<JoinSproutTherapyHomePageWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  headingSectionTitle?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  headingSectionTitle_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  headingSectionTitle_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  headingSectionTitle_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  headingSectionTitle_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  headingSectionTitle_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  headingSectionTitle_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  headingSectionTitle_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  headingSectionTitle_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  headingSectionTitle_not_ends_with?: Maybe<Scalars['String']>;
  headingSectionBtnText?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  headingSectionBtnText_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  headingSectionBtnText_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  headingSectionBtnText_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  headingSectionBtnText_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  headingSectionBtnText_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  headingSectionBtnText_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  headingSectionBtnText_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  headingSectionBtnText_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  headingSectionBtnText_not_ends_with?: Maybe<Scalars['String']>;
  headingSectionImage?: Maybe<AssetWhereInput>;
};

export enum JoinSproutTherapyHomePageOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  HeadingSectionTitleAsc = 'headingSectionTitle_ASC',
  HeadingSectionTitleDesc = 'headingSectionTitle_DESC',
  HeadingSectionBtnTextAsc = 'headingSectionBtnText_ASC',
  HeadingSectionBtnTextDesc = 'headingSectionBtnText_DESC'
}

export type JoinSproutTherapyHomePageUpdateInput = {
  headingSectionTitle?: Maybe<Scalars['String']>;
  headingSectionBtnText?: Maybe<Scalars['String']>;
  headingSectionImage?: Maybe<AssetUpdateOneInlineInput>;
};

export type JoinSproutTherapyHomePageUpdateManyInlineInput = {
  /** Create and connect multiple JoinSproutTherapyHomePage documents */
  create?: Maybe<Array<JoinSproutTherapyHomePageCreateInput>>;
  /** Connect multiple existing JoinSproutTherapyHomePage documents */
  connect?: Maybe<Array<JoinSproutTherapyHomePageConnectInput>>;
  /** Override currently-connected documents with multiple existing JoinSproutTherapyHomePage documents */
  set?: Maybe<Array<JoinSproutTherapyHomePageWhereUniqueInput>>;
  /** Update multiple JoinSproutTherapyHomePage documents */
  update?: Maybe<Array<JoinSproutTherapyHomePageUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple JoinSproutTherapyHomePage documents */
  upsert?: Maybe<Array<JoinSproutTherapyHomePageUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple JoinSproutTherapyHomePage documents */
  disconnect?: Maybe<Array<JoinSproutTherapyHomePageWhereUniqueInput>>;
  /** Delete multiple JoinSproutTherapyHomePage documents */
  delete?: Maybe<Array<JoinSproutTherapyHomePageWhereUniqueInput>>;
};

export type JoinSproutTherapyHomePageUpdateManyInput = {
  headingSectionTitle?: Maybe<Scalars['String']>;
  headingSectionBtnText?: Maybe<Scalars['String']>;
};

export type JoinSproutTherapyHomePageUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: JoinSproutTherapyHomePageWhereInput;
  /** Update many input */
  data: JoinSproutTherapyHomePageUpdateManyInput;
};

export type JoinSproutTherapyHomePageUpdateOneInlineInput = {
  /** Create and connect one JoinSproutTherapyHomePage document */
  create?: Maybe<JoinSproutTherapyHomePageCreateInput>;
  /** Update single JoinSproutTherapyHomePage document */
  update?: Maybe<JoinSproutTherapyHomePageUpdateWithNestedWhereUniqueInput>;
  /** Upsert single JoinSproutTherapyHomePage document */
  upsert?: Maybe<JoinSproutTherapyHomePageUpsertWithNestedWhereUniqueInput>;
  /** Connect existing JoinSproutTherapyHomePage document */
  connect?: Maybe<JoinSproutTherapyHomePageWhereUniqueInput>;
  /** Disconnect currently connected JoinSproutTherapyHomePage document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected JoinSproutTherapyHomePage document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type JoinSproutTherapyHomePageUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: JoinSproutTherapyHomePageWhereUniqueInput;
  /** Document to update */
  data: JoinSproutTherapyHomePageUpdateInput;
};

export type JoinSproutTherapyHomePageUpsertInput = {
  /** Create document if it didn't exist */
  create: JoinSproutTherapyHomePageCreateInput;
  /** Update document if it exists */
  update: JoinSproutTherapyHomePageUpdateInput;
};

export type JoinSproutTherapyHomePageUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: JoinSproutTherapyHomePageWhereUniqueInput;
  /** Upsert data */
  data: JoinSproutTherapyHomePageUpsertInput;
};

/** Identifies documents */
export type JoinSproutTherapyHomePageWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<JoinSproutTherapyHomePageWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<JoinSproutTherapyHomePageWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<JoinSproutTherapyHomePageWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  headingSectionTitle?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  headingSectionTitle_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  headingSectionTitle_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  headingSectionTitle_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  headingSectionTitle_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  headingSectionTitle_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  headingSectionTitle_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  headingSectionTitle_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  headingSectionTitle_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  headingSectionTitle_not_ends_with?: Maybe<Scalars['String']>;
  headingSectionBtnText?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  headingSectionBtnText_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  headingSectionBtnText_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  headingSectionBtnText_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  headingSectionBtnText_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  headingSectionBtnText_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  headingSectionBtnText_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  headingSectionBtnText_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  headingSectionBtnText_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  headingSectionBtnText_not_ends_with?: Maybe<Scalars['String']>;
  headingSectionImage?: Maybe<AssetWhereInput>;
};

/** References JoinSproutTherapyHomePage record uniquely */
export type JoinSproutTherapyHomePageWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};


/** Locale system enumeration */
export enum Locale {
  /** System locale */
  En = 'en'
}

/** Representing a geolocation point with latitude and longitude */
export type Location = {
  __typename?: 'Location';
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
  distance: Scalars['Float'];
};


/** Representing a geolocation point with latitude and longitude */
export type LocationDistanceArgs = {
  from: LocationInput;
};

/** Input for a geolocation point with latitude and longitude */
export type LocationInput = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};


export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Create one asset
   * @deprecated Asset mutations will be overhauled soon
   */
  createAsset?: Maybe<Asset>;
  /** Update one asset */
  updateAsset?: Maybe<Asset>;
  /** Delete one asset from _all_ existing stages. Returns deleted document. */
  deleteAsset?: Maybe<Asset>;
  /** Upsert one asset */
  upsertAsset?: Maybe<Asset>;
  /** Publish one asset */
  publishAsset?: Maybe<Asset>;
  /**
   * Unpublish one asset from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishAsset?: Maybe<Asset>;
  /** Update many Asset documents */
  updateManyAssetsConnection: AssetConnection;
  /** Delete many Asset documents, return deleted documents */
  deleteManyAssetsConnection: AssetConnection;
  /** Publish many Asset documents */
  publishManyAssetsConnection: AssetConnection;
  /** Find many Asset documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAssetsConnection: AssetConnection;
  /**
   * Update many assets
   * @deprecated Please use the new paginated many mutation (updateManyAssetsConnection)
   */
  updateManyAssets: BatchPayload;
  /**
   * Delete many Asset documents
   * @deprecated Please use the new paginated many mutation (deleteManyAssetsConnection)
   */
  deleteManyAssets: BatchPayload;
  /**
   * Publish many Asset documents
   * @deprecated Please use the new paginated many mutation (publishManyAssetsConnection)
   */
  publishManyAssets: BatchPayload;
  /**
   * Unpublish many Asset documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAssetsConnection)
   */
  unpublishManyAssets: BatchPayload;
  /** Create one author */
  createAuthor?: Maybe<Author>;
  /** Update one author */
  updateAuthor?: Maybe<Author>;
  /** Delete one author from _all_ existing stages. Returns deleted document. */
  deleteAuthor?: Maybe<Author>;
  /** Upsert one author */
  upsertAuthor?: Maybe<Author>;
  /** Publish one author */
  publishAuthor?: Maybe<Author>;
  /**
   * Unpublish one author from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishAuthor?: Maybe<Author>;
  /** Update many Author documents */
  updateManyAuthorsConnection: AuthorConnection;
  /** Delete many Author documents, return deleted documents */
  deleteManyAuthorsConnection: AuthorConnection;
  /** Publish many Author documents */
  publishManyAuthorsConnection: AuthorConnection;
  /** Find many Author documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyAuthorsConnection: AuthorConnection;
  /**
   * Update many authors
   * @deprecated Please use the new paginated many mutation (updateManyAuthorsConnection)
   */
  updateManyAuthors: BatchPayload;
  /**
   * Delete many Author documents
   * @deprecated Please use the new paginated many mutation (deleteManyAuthorsConnection)
   */
  deleteManyAuthors: BatchPayload;
  /**
   * Publish many Author documents
   * @deprecated Please use the new paginated many mutation (publishManyAuthorsConnection)
   */
  publishManyAuthors: BatchPayload;
  /**
   * Unpublish many Author documents
   * @deprecated Please use the new paginated many mutation (unpublishManyAuthorsConnection)
   */
  unpublishManyAuthors: BatchPayload;
  /** Create one blogParent */
  createBlogParent?: Maybe<BlogParent>;
  /** Update one blogParent */
  updateBlogParent?: Maybe<BlogParent>;
  /** Delete one blogParent from _all_ existing stages. Returns deleted document. */
  deleteBlogParent?: Maybe<BlogParent>;
  /** Upsert one blogParent */
  upsertBlogParent?: Maybe<BlogParent>;
  /** Publish one blogParent */
  publishBlogParent?: Maybe<BlogParent>;
  /**
   * Unpublish one blogParent from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishBlogParent?: Maybe<BlogParent>;
  /** Update many BlogParent documents */
  updateManyBlogParentsConnection: BlogParentConnection;
  /** Delete many BlogParent documents, return deleted documents */
  deleteManyBlogParentsConnection: BlogParentConnection;
  /** Publish many BlogParent documents */
  publishManyBlogParentsConnection: BlogParentConnection;
  /** Find many BlogParent documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBlogParentsConnection: BlogParentConnection;
  /**
   * Update many blogParents
   * @deprecated Please use the new paginated many mutation (updateManyBlogParentsConnection)
   */
  updateManyBlogParents: BatchPayload;
  /**
   * Delete many BlogParent documents
   * @deprecated Please use the new paginated many mutation (deleteManyBlogParentsConnection)
   */
  deleteManyBlogParents: BatchPayload;
  /**
   * Publish many BlogParent documents
   * @deprecated Please use the new paginated many mutation (publishManyBlogParentsConnection)
   */
  publishManyBlogParents: BatchPayload;
  /**
   * Unpublish many BlogParent documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBlogParentsConnection)
   */
  unpublishManyBlogParents: BatchPayload;
  /** Create one blogPost */
  createBlogPost?: Maybe<BlogPost>;
  /** Update one blogPost */
  updateBlogPost?: Maybe<BlogPost>;
  /** Delete one blogPost from _all_ existing stages. Returns deleted document. */
  deleteBlogPost?: Maybe<BlogPost>;
  /** Upsert one blogPost */
  upsertBlogPost?: Maybe<BlogPost>;
  /** Publish one blogPost */
  publishBlogPost?: Maybe<BlogPost>;
  /**
   * Unpublish one blogPost from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishBlogPost?: Maybe<BlogPost>;
  /** Update many BlogPost documents */
  updateManyBlogPostsConnection: BlogPostConnection;
  /** Delete many BlogPost documents, return deleted documents */
  deleteManyBlogPostsConnection: BlogPostConnection;
  /** Publish many BlogPost documents */
  publishManyBlogPostsConnection: BlogPostConnection;
  /** Find many BlogPost documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyBlogPostsConnection: BlogPostConnection;
  /**
   * Update many blogPosts
   * @deprecated Please use the new paginated many mutation (updateManyBlogPostsConnection)
   */
  updateManyBlogPosts: BatchPayload;
  /**
   * Delete many BlogPost documents
   * @deprecated Please use the new paginated many mutation (deleteManyBlogPostsConnection)
   */
  deleteManyBlogPosts: BatchPayload;
  /**
   * Publish many BlogPost documents
   * @deprecated Please use the new paginated many mutation (publishManyBlogPostsConnection)
   */
  publishManyBlogPosts: BatchPayload;
  /**
   * Unpublish many BlogPost documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBlogPostsConnection)
   */
  unpublishManyBlogPosts: BatchPayload;
  /** Create one bookingLearnMoreAboutAutismGroup */
  createBookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroup>;
  /** Update one bookingLearnMoreAboutAutismGroup */
  updateBookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroup>;
  /** Delete one bookingLearnMoreAboutAutismGroup from _all_ existing stages. Returns deleted document. */
  deleteBookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroup>;
  /** Upsert one bookingLearnMoreAboutAutismGroup */
  upsertBookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroup>;
  /** Publish one bookingLearnMoreAboutAutismGroup */
  publishBookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroup>;
  /**
   * Unpublish one bookingLearnMoreAboutAutismGroup from selected stages. Unpublish
   * either the complete document with its relations, localizations and base data
   * or specific localizations only.
   */
  unpublishBookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroup>;
  /** Update many BookingLearnMoreAboutAutismGroup documents */
  updateManyBookingLearnMoreAboutAutismGroupsConnection: BookingLearnMoreAboutAutismGroupConnection;
  /** Delete many BookingLearnMoreAboutAutismGroup documents, return deleted documents */
  deleteManyBookingLearnMoreAboutAutismGroupsConnection: BookingLearnMoreAboutAutismGroupConnection;
  /** Publish many BookingLearnMoreAboutAutismGroup documents */
  publishManyBookingLearnMoreAboutAutismGroupsConnection: BookingLearnMoreAboutAutismGroupConnection;
  /**
   * Find many BookingLearnMoreAboutAutismGroup documents that match criteria in
   * specified stage and unpublish from target stages
   */
  unpublishManyBookingLearnMoreAboutAutismGroupsConnection: BookingLearnMoreAboutAutismGroupConnection;
  /**
   * Update many bookingLearnMoreAboutAutismGroups
   * @deprecated Please use the new paginated many mutation (updateManyBookingLearnMoreAboutAutismGroupsConnection)
   */
  updateManyBookingLearnMoreAboutAutismGroups: BatchPayload;
  /**
   * Delete many BookingLearnMoreAboutAutismGroup documents
   * @deprecated Please use the new paginated many mutation (deleteManyBookingLearnMoreAboutAutismGroupsConnection)
   */
  deleteManyBookingLearnMoreAboutAutismGroups: BatchPayload;
  /**
   * Publish many BookingLearnMoreAboutAutismGroup documents
   * @deprecated Please use the new paginated many mutation (publishManyBookingLearnMoreAboutAutismGroupsConnection)
   */
  publishManyBookingLearnMoreAboutAutismGroups: BatchPayload;
  /**
   * Unpublish many BookingLearnMoreAboutAutismGroup documents
   * @deprecated Please use the new paginated many mutation (unpublishManyBookingLearnMoreAboutAutismGroupsConnection)
   */
  unpublishManyBookingLearnMoreAboutAutismGroups: BatchPayload;
  /** Create one city */
  createCity?: Maybe<City>;
  /** Update one city */
  updateCity?: Maybe<City>;
  /** Delete one city from _all_ existing stages. Returns deleted document. */
  deleteCity?: Maybe<City>;
  /** Upsert one city */
  upsertCity?: Maybe<City>;
  /** Publish one city */
  publishCity?: Maybe<City>;
  /**
   * Unpublish one city from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishCity?: Maybe<City>;
  /** Update many City documents */
  updateManyCitiesConnection: CityConnection;
  /** Delete many City documents, return deleted documents */
  deleteManyCitiesConnection: CityConnection;
  /** Publish many City documents */
  publishManyCitiesConnection: CityConnection;
  /** Find many City documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyCitiesConnection: CityConnection;
  /**
   * Update many cities
   * @deprecated Please use the new paginated many mutation (updateManyCitiesConnection)
   */
  updateManyCities: BatchPayload;
  /**
   * Delete many City documents
   * @deprecated Please use the new paginated many mutation (deleteManyCitiesConnection)
   */
  deleteManyCities: BatchPayload;
  /**
   * Publish many City documents
   * @deprecated Please use the new paginated many mutation (publishManyCitiesConnection)
   */
  publishManyCities: BatchPayload;
  /**
   * Unpublish many City documents
   * @deprecated Please use the new paginated many mutation (unpublishManyCitiesConnection)
   */
  unpublishManyCities: BatchPayload;
  /** Create one clinic */
  createClinic?: Maybe<Clinic>;
  /** Update one clinic */
  updateClinic?: Maybe<Clinic>;
  /** Delete one clinic from _all_ existing stages. Returns deleted document. */
  deleteClinic?: Maybe<Clinic>;
  /** Upsert one clinic */
  upsertClinic?: Maybe<Clinic>;
  /** Publish one clinic */
  publishClinic?: Maybe<Clinic>;
  /**
   * Unpublish one clinic from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishClinic?: Maybe<Clinic>;
  /** Update many Clinic documents */
  updateManyClinicsConnection: ClinicConnection;
  /** Delete many Clinic documents, return deleted documents */
  deleteManyClinicsConnection: ClinicConnection;
  /** Publish many Clinic documents */
  publishManyClinicsConnection: ClinicConnection;
  /** Find many Clinic documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyClinicsConnection: ClinicConnection;
  /**
   * Update many clinics
   * @deprecated Please use the new paginated many mutation (updateManyClinicsConnection)
   */
  updateManyClinics: BatchPayload;
  /**
   * Delete many Clinic documents
   * @deprecated Please use the new paginated many mutation (deleteManyClinicsConnection)
   */
  deleteManyClinics: BatchPayload;
  /**
   * Publish many Clinic documents
   * @deprecated Please use the new paginated many mutation (publishManyClinicsConnection)
   */
  publishManyClinics: BatchPayload;
  /**
   * Unpublish many Clinic documents
   * @deprecated Please use the new paginated many mutation (unpublishManyClinicsConnection)
   */
  unpublishManyClinics: BatchPayload;
  /** Create one joinSproutTherapyHomePage */
  createJoinSproutTherapyHomePage?: Maybe<JoinSproutTherapyHomePage>;
  /** Update one joinSproutTherapyHomePage */
  updateJoinSproutTherapyHomePage?: Maybe<JoinSproutTherapyHomePage>;
  /** Delete one joinSproutTherapyHomePage from _all_ existing stages. Returns deleted document. */
  deleteJoinSproutTherapyHomePage?: Maybe<JoinSproutTherapyHomePage>;
  /** Upsert one joinSproutTherapyHomePage */
  upsertJoinSproutTherapyHomePage?: Maybe<JoinSproutTherapyHomePage>;
  /** Publish one joinSproutTherapyHomePage */
  publishJoinSproutTherapyHomePage?: Maybe<JoinSproutTherapyHomePage>;
  /**
   * Unpublish one joinSproutTherapyHomePage from selected stages. Unpublish either
   * the complete document with its relations, localizations and base data or
   * specific localizations only.
   */
  unpublishJoinSproutTherapyHomePage?: Maybe<JoinSproutTherapyHomePage>;
  /** Update many JoinSproutTherapyHomePage documents */
  updateManyJoinSproutTherapyHomePagesConnection: JoinSproutTherapyHomePageConnection;
  /** Delete many JoinSproutTherapyHomePage documents, return deleted documents */
  deleteManyJoinSproutTherapyHomePagesConnection: JoinSproutTherapyHomePageConnection;
  /** Publish many JoinSproutTherapyHomePage documents */
  publishManyJoinSproutTherapyHomePagesConnection: JoinSproutTherapyHomePageConnection;
  /** Find many JoinSproutTherapyHomePage documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyJoinSproutTherapyHomePagesConnection: JoinSproutTherapyHomePageConnection;
  /**
   * Update many joinSproutTherapyHomePages
   * @deprecated Please use the new paginated many mutation (updateManyJoinSproutTherapyHomePagesConnection)
   */
  updateManyJoinSproutTherapyHomePages: BatchPayload;
  /**
   * Delete many JoinSproutTherapyHomePage documents
   * @deprecated Please use the new paginated many mutation (deleteManyJoinSproutTherapyHomePagesConnection)
   */
  deleteManyJoinSproutTherapyHomePages: BatchPayload;
  /**
   * Publish many JoinSproutTherapyHomePage documents
   * @deprecated Please use the new paginated many mutation (publishManyJoinSproutTherapyHomePagesConnection)
   */
  publishManyJoinSproutTherapyHomePages: BatchPayload;
  /**
   * Unpublish many JoinSproutTherapyHomePage documents
   * @deprecated Please use the new paginated many mutation (unpublishManyJoinSproutTherapyHomePagesConnection)
   */
  unpublishManyJoinSproutTherapyHomePages: BatchPayload;
  /** Create one pageSection */
  createPageSection?: Maybe<PageSection>;
  /** Update one pageSection */
  updatePageSection?: Maybe<PageSection>;
  /** Delete one pageSection from _all_ existing stages. Returns deleted document. */
  deletePageSection?: Maybe<PageSection>;
  /** Upsert one pageSection */
  upsertPageSection?: Maybe<PageSection>;
  /** Publish one pageSection */
  publishPageSection?: Maybe<PageSection>;
  /**
   * Unpublish one pageSection from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishPageSection?: Maybe<PageSection>;
  /** Update many PageSection documents */
  updateManyPageSectionsConnection: PageSectionConnection;
  /** Delete many PageSection documents, return deleted documents */
  deleteManyPageSectionsConnection: PageSectionConnection;
  /** Publish many PageSection documents */
  publishManyPageSectionsConnection: PageSectionConnection;
  /** Find many PageSection documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyPageSectionsConnection: PageSectionConnection;
  /**
   * Update many pageSections
   * @deprecated Please use the new paginated many mutation (updateManyPageSectionsConnection)
   */
  updateManyPageSections: BatchPayload;
  /**
   * Delete many PageSection documents
   * @deprecated Please use the new paginated many mutation (deleteManyPageSectionsConnection)
   */
  deleteManyPageSections: BatchPayload;
  /**
   * Publish many PageSection documents
   * @deprecated Please use the new paginated many mutation (publishManyPageSectionsConnection)
   */
  publishManyPageSections: BatchPayload;
  /**
   * Unpublish many PageSection documents
   * @deprecated Please use the new paginated many mutation (unpublishManyPageSectionsConnection)
   */
  unpublishManyPageSections: BatchPayload;
  /** Create one provider */
  createProvider?: Maybe<Provider>;
  /** Update one provider */
  updateProvider?: Maybe<Provider>;
  /** Delete one provider from _all_ existing stages. Returns deleted document. */
  deleteProvider?: Maybe<Provider>;
  /** Upsert one provider */
  upsertProvider?: Maybe<Provider>;
  /** Publish one provider */
  publishProvider?: Maybe<Provider>;
  /**
   * Unpublish one provider from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishProvider?: Maybe<Provider>;
  /** Update many Provider documents */
  updateManyProvidersConnection: ProviderConnection;
  /** Delete many Provider documents, return deleted documents */
  deleteManyProvidersConnection: ProviderConnection;
  /** Publish many Provider documents */
  publishManyProvidersConnection: ProviderConnection;
  /** Find many Provider documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProvidersConnection: ProviderConnection;
  /**
   * Update many providers
   * @deprecated Please use the new paginated many mutation (updateManyProvidersConnection)
   */
  updateManyProviders: BatchPayload;
  /**
   * Delete many Provider documents
   * @deprecated Please use the new paginated many mutation (deleteManyProvidersConnection)
   */
  deleteManyProviders: BatchPayload;
  /**
   * Publish many Provider documents
   * @deprecated Please use the new paginated many mutation (publishManyProvidersConnection)
   */
  publishManyProviders: BatchPayload;
  /**
   * Unpublish many Provider documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProvidersConnection)
   */
  unpublishManyProviders: BatchPayload;
  /** Create one providerLink */
  createProviderLink?: Maybe<ProviderLink>;
  /** Update one providerLink */
  updateProviderLink?: Maybe<ProviderLink>;
  /** Delete one providerLink from _all_ existing stages. Returns deleted document. */
  deleteProviderLink?: Maybe<ProviderLink>;
  /** Upsert one providerLink */
  upsertProviderLink?: Maybe<ProviderLink>;
  /** Publish one providerLink */
  publishProviderLink?: Maybe<ProviderLink>;
  /**
   * Unpublish one providerLink from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishProviderLink?: Maybe<ProviderLink>;
  /** Update many ProviderLink documents */
  updateManyProviderLinksConnection: ProviderLinkConnection;
  /** Delete many ProviderLink documents, return deleted documents */
  deleteManyProviderLinksConnection: ProviderLinkConnection;
  /** Publish many ProviderLink documents */
  publishManyProviderLinksConnection: ProviderLinkConnection;
  /** Find many ProviderLink documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyProviderLinksConnection: ProviderLinkConnection;
  /**
   * Update many providerLinks
   * @deprecated Please use the new paginated many mutation (updateManyProviderLinksConnection)
   */
  updateManyProviderLinks: BatchPayload;
  /**
   * Delete many ProviderLink documents
   * @deprecated Please use the new paginated many mutation (deleteManyProviderLinksConnection)
   */
  deleteManyProviderLinks: BatchPayload;
  /**
   * Publish many ProviderLink documents
   * @deprecated Please use the new paginated many mutation (publishManyProviderLinksConnection)
   */
  publishManyProviderLinks: BatchPayload;
  /**
   * Unpublish many ProviderLink documents
   * @deprecated Please use the new paginated many mutation (unpublishManyProviderLinksConnection)
   */
  unpublishManyProviderLinks: BatchPayload;
  /** Create one seoDataItem */
  createSeoDataItem?: Maybe<SeoDataItem>;
  /** Update one seoDataItem */
  updateSeoDataItem?: Maybe<SeoDataItem>;
  /** Delete one seoDataItem from _all_ existing stages. Returns deleted document. */
  deleteSeoDataItem?: Maybe<SeoDataItem>;
  /** Upsert one seoDataItem */
  upsertSeoDataItem?: Maybe<SeoDataItem>;
  /** Publish one seoDataItem */
  publishSeoDataItem?: Maybe<SeoDataItem>;
  /**
   * Unpublish one seoDataItem from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishSeoDataItem?: Maybe<SeoDataItem>;
  /** Update many SeoDataItem documents */
  updateManySeoDataItemsConnection: SeoDataItemConnection;
  /** Delete many SeoDataItem documents, return deleted documents */
  deleteManySeoDataItemsConnection: SeoDataItemConnection;
  /** Publish many SeoDataItem documents */
  publishManySeoDataItemsConnection: SeoDataItemConnection;
  /** Find many SeoDataItem documents that match criteria in specified stage and unpublish from target stages */
  unpublishManySeoDataItemsConnection: SeoDataItemConnection;
  /**
   * Update many seoDataItems
   * @deprecated Please use the new paginated many mutation (updateManySeoDataItemsConnection)
   */
  updateManySeoDataItems: BatchPayload;
  /**
   * Delete many SeoDataItem documents
   * @deprecated Please use the new paginated many mutation (deleteManySeoDataItemsConnection)
   */
  deleteManySeoDataItems: BatchPayload;
  /**
   * Publish many SeoDataItem documents
   * @deprecated Please use the new paginated many mutation (publishManySeoDataItemsConnection)
   */
  publishManySeoDataItems: BatchPayload;
  /**
   * Unpublish many SeoDataItem documents
   * @deprecated Please use the new paginated many mutation (unpublishManySeoDataItemsConnection)
   */
  unpublishManySeoDataItems: BatchPayload;
  /** Create one state */
  createState?: Maybe<State>;
  /** Update one state */
  updateState?: Maybe<State>;
  /** Delete one state from _all_ existing stages. Returns deleted document. */
  deleteState?: Maybe<State>;
  /** Upsert one state */
  upsertState?: Maybe<State>;
  /** Publish one state */
  publishState?: Maybe<State>;
  /**
   * Unpublish one state from selected stages. Unpublish either the complete
   * document with its relations, localizations and base data or specific
   * localizations only.
   */
  unpublishState?: Maybe<State>;
  /** Update many State documents */
  updateManyStatesConnection: StateConnection;
  /** Delete many State documents, return deleted documents */
  deleteManyStatesConnection: StateConnection;
  /** Publish many State documents */
  publishManyStatesConnection: StateConnection;
  /** Find many State documents that match criteria in specified stage and unpublish from target stages */
  unpublishManyStatesConnection: StateConnection;
  /**
   * Update many states
   * @deprecated Please use the new paginated many mutation (updateManyStatesConnection)
   */
  updateManyStates: BatchPayload;
  /**
   * Delete many State documents
   * @deprecated Please use the new paginated many mutation (deleteManyStatesConnection)
   */
  deleteManyStates: BatchPayload;
  /**
   * Publish many State documents
   * @deprecated Please use the new paginated many mutation (publishManyStatesConnection)
   */
  publishManyStates: BatchPayload;
  /**
   * Unpublish many State documents
   * @deprecated Please use the new paginated many mutation (unpublishManyStatesConnection)
   */
  unpublishManyStates: BatchPayload;
};


export type MutationCreateAssetArgs = {
  data: AssetCreateInput;
};


export type MutationUpdateAssetArgs = {
  where: AssetWhereUniqueInput;
  data: AssetUpdateInput;
};


export type MutationDeleteAssetArgs = {
  where: AssetWhereUniqueInput;
};


export type MutationUpsertAssetArgs = {
  where: AssetWhereUniqueInput;
  upsert: AssetUpsertInput;
};


export type MutationPublishAssetArgs = {
  where: AssetWhereUniqueInput;
  locales?: Maybe<Array<Locale>>;
  publishBase?: Maybe<Scalars['Boolean']>;
  withDefaultLocale?: Maybe<Scalars['Boolean']>;
  to?: Array<Stage>;
};


export type MutationUnpublishAssetArgs = {
  where: AssetWhereUniqueInput;
  from?: Array<Stage>;
  locales?: Maybe<Array<Locale>>;
  unpublishBase?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateManyAssetsConnectionArgs = {
  where?: Maybe<AssetManyWhereInput>;
  data: AssetUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyAssetsConnectionArgs = {
  where?: Maybe<AssetManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyAssetsConnectionArgs = {
  where?: Maybe<AssetManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  locales?: Maybe<Array<Locale>>;
  publishBase?: Maybe<Scalars['Boolean']>;
  withDefaultLocale?: Maybe<Scalars['Boolean']>;
};


export type MutationUnpublishManyAssetsConnectionArgs = {
  where?: Maybe<AssetManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
  locales?: Maybe<Array<Locale>>;
  unpublishBase?: Maybe<Scalars['Boolean']>;
};


export type MutationUpdateManyAssetsArgs = {
  where?: Maybe<AssetManyWhereInput>;
  data: AssetUpdateManyInput;
};


export type MutationDeleteManyAssetsArgs = {
  where?: Maybe<AssetManyWhereInput>;
};


export type MutationPublishManyAssetsArgs = {
  where?: Maybe<AssetManyWhereInput>;
  to?: Array<Stage>;
  locales?: Maybe<Array<Locale>>;
  publishBase?: Maybe<Scalars['Boolean']>;
  withDefaultLocale?: Maybe<Scalars['Boolean']>;
};


export type MutationUnpublishManyAssetsArgs = {
  where?: Maybe<AssetManyWhereInput>;
  from?: Array<Stage>;
  locales?: Maybe<Array<Locale>>;
  unpublishBase?: Maybe<Scalars['Boolean']>;
};


export type MutationCreateAuthorArgs = {
  data: AuthorCreateInput;
};


export type MutationUpdateAuthorArgs = {
  where: AuthorWhereUniqueInput;
  data: AuthorUpdateInput;
};


export type MutationDeleteAuthorArgs = {
  where: AuthorWhereUniqueInput;
};


export type MutationUpsertAuthorArgs = {
  where: AuthorWhereUniqueInput;
  upsert: AuthorUpsertInput;
};


export type MutationPublishAuthorArgs = {
  where: AuthorWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishAuthorArgs = {
  where: AuthorWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyAuthorsConnectionArgs = {
  where?: Maybe<AuthorManyWhereInput>;
  data: AuthorUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyAuthorsConnectionArgs = {
  where?: Maybe<AuthorManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyAuthorsConnectionArgs = {
  where?: Maybe<AuthorManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyAuthorsConnectionArgs = {
  where?: Maybe<AuthorManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyAuthorsArgs = {
  where?: Maybe<AuthorManyWhereInput>;
  data: AuthorUpdateManyInput;
};


export type MutationDeleteManyAuthorsArgs = {
  where?: Maybe<AuthorManyWhereInput>;
};


export type MutationPublishManyAuthorsArgs = {
  where?: Maybe<AuthorManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyAuthorsArgs = {
  where?: Maybe<AuthorManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateBlogParentArgs = {
  data: BlogParentCreateInput;
};


export type MutationUpdateBlogParentArgs = {
  where: BlogParentWhereUniqueInput;
  data: BlogParentUpdateInput;
};


export type MutationDeleteBlogParentArgs = {
  where: BlogParentWhereUniqueInput;
};


export type MutationUpsertBlogParentArgs = {
  where: BlogParentWhereUniqueInput;
  upsert: BlogParentUpsertInput;
};


export type MutationPublishBlogParentArgs = {
  where: BlogParentWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishBlogParentArgs = {
  where: BlogParentWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyBlogParentsConnectionArgs = {
  where?: Maybe<BlogParentManyWhereInput>;
  data: BlogParentUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyBlogParentsConnectionArgs = {
  where?: Maybe<BlogParentManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyBlogParentsConnectionArgs = {
  where?: Maybe<BlogParentManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyBlogParentsConnectionArgs = {
  where?: Maybe<BlogParentManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyBlogParentsArgs = {
  where?: Maybe<BlogParentManyWhereInput>;
  data: BlogParentUpdateManyInput;
};


export type MutationDeleteManyBlogParentsArgs = {
  where?: Maybe<BlogParentManyWhereInput>;
};


export type MutationPublishManyBlogParentsArgs = {
  where?: Maybe<BlogParentManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyBlogParentsArgs = {
  where?: Maybe<BlogParentManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateBlogPostArgs = {
  data: BlogPostCreateInput;
};


export type MutationUpdateBlogPostArgs = {
  where: BlogPostWhereUniqueInput;
  data: BlogPostUpdateInput;
};


export type MutationDeleteBlogPostArgs = {
  where: BlogPostWhereUniqueInput;
};


export type MutationUpsertBlogPostArgs = {
  where: BlogPostWhereUniqueInput;
  upsert: BlogPostUpsertInput;
};


export type MutationPublishBlogPostArgs = {
  where: BlogPostWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishBlogPostArgs = {
  where: BlogPostWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyBlogPostsConnectionArgs = {
  where?: Maybe<BlogPostManyWhereInput>;
  data: BlogPostUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyBlogPostsConnectionArgs = {
  where?: Maybe<BlogPostManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyBlogPostsConnectionArgs = {
  where?: Maybe<BlogPostManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyBlogPostsConnectionArgs = {
  where?: Maybe<BlogPostManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyBlogPostsArgs = {
  where?: Maybe<BlogPostManyWhereInput>;
  data: BlogPostUpdateManyInput;
};


export type MutationDeleteManyBlogPostsArgs = {
  where?: Maybe<BlogPostManyWhereInput>;
};


export type MutationPublishManyBlogPostsArgs = {
  where?: Maybe<BlogPostManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyBlogPostsArgs = {
  where?: Maybe<BlogPostManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateBookingLearnMoreAboutAutismGroupArgs = {
  data: BookingLearnMoreAboutAutismGroupCreateInput;
};


export type MutationUpdateBookingLearnMoreAboutAutismGroupArgs = {
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
  data: BookingLearnMoreAboutAutismGroupUpdateInput;
};


export type MutationDeleteBookingLearnMoreAboutAutismGroupArgs = {
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
};


export type MutationUpsertBookingLearnMoreAboutAutismGroupArgs = {
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
  upsert: BookingLearnMoreAboutAutismGroupUpsertInput;
};


export type MutationPublishBookingLearnMoreAboutAutismGroupArgs = {
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishBookingLearnMoreAboutAutismGroupArgs = {
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyBookingLearnMoreAboutAutismGroupsConnectionArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupManyWhereInput>;
  data: BookingLearnMoreAboutAutismGroupUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyBookingLearnMoreAboutAutismGroupsConnectionArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyBookingLearnMoreAboutAutismGroupsConnectionArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyBookingLearnMoreAboutAutismGroupsConnectionArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyBookingLearnMoreAboutAutismGroupsArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupManyWhereInput>;
  data: BookingLearnMoreAboutAutismGroupUpdateManyInput;
};


export type MutationDeleteManyBookingLearnMoreAboutAutismGroupsArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupManyWhereInput>;
};


export type MutationPublishManyBookingLearnMoreAboutAutismGroupsArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyBookingLearnMoreAboutAutismGroupsArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateCityArgs = {
  data: CityCreateInput;
};


export type MutationUpdateCityArgs = {
  where: CityWhereUniqueInput;
  data: CityUpdateInput;
};


export type MutationDeleteCityArgs = {
  where: CityWhereUniqueInput;
};


export type MutationUpsertCityArgs = {
  where: CityWhereUniqueInput;
  upsert: CityUpsertInput;
};


export type MutationPublishCityArgs = {
  where: CityWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishCityArgs = {
  where: CityWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyCitiesConnectionArgs = {
  where?: Maybe<CityManyWhereInput>;
  data: CityUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyCitiesConnectionArgs = {
  where?: Maybe<CityManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyCitiesConnectionArgs = {
  where?: Maybe<CityManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyCitiesConnectionArgs = {
  where?: Maybe<CityManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyCitiesArgs = {
  where?: Maybe<CityManyWhereInput>;
  data: CityUpdateManyInput;
};


export type MutationDeleteManyCitiesArgs = {
  where?: Maybe<CityManyWhereInput>;
};


export type MutationPublishManyCitiesArgs = {
  where?: Maybe<CityManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyCitiesArgs = {
  where?: Maybe<CityManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateClinicArgs = {
  data: ClinicCreateInput;
};


export type MutationUpdateClinicArgs = {
  where: ClinicWhereUniqueInput;
  data: ClinicUpdateInput;
};


export type MutationDeleteClinicArgs = {
  where: ClinicWhereUniqueInput;
};


export type MutationUpsertClinicArgs = {
  where: ClinicWhereUniqueInput;
  upsert: ClinicUpsertInput;
};


export type MutationPublishClinicArgs = {
  where: ClinicWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishClinicArgs = {
  where: ClinicWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyClinicsConnectionArgs = {
  where?: Maybe<ClinicManyWhereInput>;
  data: ClinicUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyClinicsConnectionArgs = {
  where?: Maybe<ClinicManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyClinicsConnectionArgs = {
  where?: Maybe<ClinicManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyClinicsConnectionArgs = {
  where?: Maybe<ClinicManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyClinicsArgs = {
  where?: Maybe<ClinicManyWhereInput>;
  data: ClinicUpdateManyInput;
};


export type MutationDeleteManyClinicsArgs = {
  where?: Maybe<ClinicManyWhereInput>;
};


export type MutationPublishManyClinicsArgs = {
  where?: Maybe<ClinicManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyClinicsArgs = {
  where?: Maybe<ClinicManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateJoinSproutTherapyHomePageArgs = {
  data: JoinSproutTherapyHomePageCreateInput;
};


export type MutationUpdateJoinSproutTherapyHomePageArgs = {
  where: JoinSproutTherapyHomePageWhereUniqueInput;
  data: JoinSproutTherapyHomePageUpdateInput;
};


export type MutationDeleteJoinSproutTherapyHomePageArgs = {
  where: JoinSproutTherapyHomePageWhereUniqueInput;
};


export type MutationUpsertJoinSproutTherapyHomePageArgs = {
  where: JoinSproutTherapyHomePageWhereUniqueInput;
  upsert: JoinSproutTherapyHomePageUpsertInput;
};


export type MutationPublishJoinSproutTherapyHomePageArgs = {
  where: JoinSproutTherapyHomePageWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishJoinSproutTherapyHomePageArgs = {
  where: JoinSproutTherapyHomePageWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyJoinSproutTherapyHomePagesConnectionArgs = {
  where?: Maybe<JoinSproutTherapyHomePageManyWhereInput>;
  data: JoinSproutTherapyHomePageUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyJoinSproutTherapyHomePagesConnectionArgs = {
  where?: Maybe<JoinSproutTherapyHomePageManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyJoinSproutTherapyHomePagesConnectionArgs = {
  where?: Maybe<JoinSproutTherapyHomePageManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyJoinSproutTherapyHomePagesConnectionArgs = {
  where?: Maybe<JoinSproutTherapyHomePageManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyJoinSproutTherapyHomePagesArgs = {
  where?: Maybe<JoinSproutTherapyHomePageManyWhereInput>;
  data: JoinSproutTherapyHomePageUpdateManyInput;
};


export type MutationDeleteManyJoinSproutTherapyHomePagesArgs = {
  where?: Maybe<JoinSproutTherapyHomePageManyWhereInput>;
};


export type MutationPublishManyJoinSproutTherapyHomePagesArgs = {
  where?: Maybe<JoinSproutTherapyHomePageManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyJoinSproutTherapyHomePagesArgs = {
  where?: Maybe<JoinSproutTherapyHomePageManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreatePageSectionArgs = {
  data: PageSectionCreateInput;
};


export type MutationUpdatePageSectionArgs = {
  where: PageSectionWhereUniqueInput;
  data: PageSectionUpdateInput;
};


export type MutationDeletePageSectionArgs = {
  where: PageSectionWhereUniqueInput;
};


export type MutationUpsertPageSectionArgs = {
  where: PageSectionWhereUniqueInput;
  upsert: PageSectionUpsertInput;
};


export type MutationPublishPageSectionArgs = {
  where: PageSectionWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishPageSectionArgs = {
  where: PageSectionWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyPageSectionsConnectionArgs = {
  where?: Maybe<PageSectionManyWhereInput>;
  data: PageSectionUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyPageSectionsConnectionArgs = {
  where?: Maybe<PageSectionManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyPageSectionsConnectionArgs = {
  where?: Maybe<PageSectionManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyPageSectionsConnectionArgs = {
  where?: Maybe<PageSectionManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyPageSectionsArgs = {
  where?: Maybe<PageSectionManyWhereInput>;
  data: PageSectionUpdateManyInput;
};


export type MutationDeleteManyPageSectionsArgs = {
  where?: Maybe<PageSectionManyWhereInput>;
};


export type MutationPublishManyPageSectionsArgs = {
  where?: Maybe<PageSectionManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyPageSectionsArgs = {
  where?: Maybe<PageSectionManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateProviderArgs = {
  data: ProviderCreateInput;
};


export type MutationUpdateProviderArgs = {
  where: ProviderWhereUniqueInput;
  data: ProviderUpdateInput;
};


export type MutationDeleteProviderArgs = {
  where: ProviderWhereUniqueInput;
};


export type MutationUpsertProviderArgs = {
  where: ProviderWhereUniqueInput;
  upsert: ProviderUpsertInput;
};


export type MutationPublishProviderArgs = {
  where: ProviderWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishProviderArgs = {
  where: ProviderWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyProvidersConnectionArgs = {
  where?: Maybe<ProviderManyWhereInput>;
  data: ProviderUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyProvidersConnectionArgs = {
  where?: Maybe<ProviderManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyProvidersConnectionArgs = {
  where?: Maybe<ProviderManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyProvidersConnectionArgs = {
  where?: Maybe<ProviderManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyProvidersArgs = {
  where?: Maybe<ProviderManyWhereInput>;
  data: ProviderUpdateManyInput;
};


export type MutationDeleteManyProvidersArgs = {
  where?: Maybe<ProviderManyWhereInput>;
};


export type MutationPublishManyProvidersArgs = {
  where?: Maybe<ProviderManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyProvidersArgs = {
  where?: Maybe<ProviderManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateProviderLinkArgs = {
  data: ProviderLinkCreateInput;
};


export type MutationUpdateProviderLinkArgs = {
  where: ProviderLinkWhereUniqueInput;
  data: ProviderLinkUpdateInput;
};


export type MutationDeleteProviderLinkArgs = {
  where: ProviderLinkWhereUniqueInput;
};


export type MutationUpsertProviderLinkArgs = {
  where: ProviderLinkWhereUniqueInput;
  upsert: ProviderLinkUpsertInput;
};


export type MutationPublishProviderLinkArgs = {
  where: ProviderLinkWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishProviderLinkArgs = {
  where: ProviderLinkWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyProviderLinksConnectionArgs = {
  where?: Maybe<ProviderLinkManyWhereInput>;
  data: ProviderLinkUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyProviderLinksConnectionArgs = {
  where?: Maybe<ProviderLinkManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyProviderLinksConnectionArgs = {
  where?: Maybe<ProviderLinkManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyProviderLinksConnectionArgs = {
  where?: Maybe<ProviderLinkManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyProviderLinksArgs = {
  where?: Maybe<ProviderLinkManyWhereInput>;
  data: ProviderLinkUpdateManyInput;
};


export type MutationDeleteManyProviderLinksArgs = {
  where?: Maybe<ProviderLinkManyWhereInput>;
};


export type MutationPublishManyProviderLinksArgs = {
  where?: Maybe<ProviderLinkManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyProviderLinksArgs = {
  where?: Maybe<ProviderLinkManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateSeoDataItemArgs = {
  data: SeoDataItemCreateInput;
};


export type MutationUpdateSeoDataItemArgs = {
  where: SeoDataItemWhereUniqueInput;
  data: SeoDataItemUpdateInput;
};


export type MutationDeleteSeoDataItemArgs = {
  where: SeoDataItemWhereUniqueInput;
};


export type MutationUpsertSeoDataItemArgs = {
  where: SeoDataItemWhereUniqueInput;
  upsert: SeoDataItemUpsertInput;
};


export type MutationPublishSeoDataItemArgs = {
  where: SeoDataItemWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishSeoDataItemArgs = {
  where: SeoDataItemWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManySeoDataItemsConnectionArgs = {
  where?: Maybe<SeoDataItemManyWhereInput>;
  data: SeoDataItemUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManySeoDataItemsConnectionArgs = {
  where?: Maybe<SeoDataItemManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManySeoDataItemsConnectionArgs = {
  where?: Maybe<SeoDataItemManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManySeoDataItemsConnectionArgs = {
  where?: Maybe<SeoDataItemManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManySeoDataItemsArgs = {
  where?: Maybe<SeoDataItemManyWhereInput>;
  data: SeoDataItemUpdateManyInput;
};


export type MutationDeleteManySeoDataItemsArgs = {
  where?: Maybe<SeoDataItemManyWhereInput>;
};


export type MutationPublishManySeoDataItemsArgs = {
  where?: Maybe<SeoDataItemManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManySeoDataItemsArgs = {
  where?: Maybe<SeoDataItemManyWhereInput>;
  from?: Array<Stage>;
};


export type MutationCreateStateArgs = {
  data: StateCreateInput;
};


export type MutationUpdateStateArgs = {
  where: StateWhereUniqueInput;
  data: StateUpdateInput;
};


export type MutationDeleteStateArgs = {
  where: StateWhereUniqueInput;
};


export type MutationUpsertStateArgs = {
  where: StateWhereUniqueInput;
  upsert: StateUpsertInput;
};


export type MutationPublishStateArgs = {
  where: StateWhereUniqueInput;
  to?: Array<Stage>;
};


export type MutationUnpublishStateArgs = {
  where: StateWhereUniqueInput;
  from?: Array<Stage>;
};


export type MutationUpdateManyStatesConnectionArgs = {
  where?: Maybe<StateManyWhereInput>;
  data: StateUpdateManyInput;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationDeleteManyStatesConnectionArgs = {
  where?: Maybe<StateManyWhereInput>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationPublishManyStatesConnectionArgs = {
  where?: Maybe<StateManyWhereInput>;
  from?: Maybe<Stage>;
  to?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUnpublishManyStatesConnectionArgs = {
  where?: Maybe<StateManyWhereInput>;
  stage?: Maybe<Stage>;
  from?: Array<Stage>;
  skip?: Maybe<Scalars['Int']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  before?: Maybe<Scalars['ID']>;
  after?: Maybe<Scalars['ID']>;
};


export type MutationUpdateManyStatesArgs = {
  where?: Maybe<StateManyWhereInput>;
  data: StateUpdateManyInput;
};


export type MutationDeleteManyStatesArgs = {
  where?: Maybe<StateManyWhereInput>;
};


export type MutationPublishManyStatesArgs = {
  where?: Maybe<StateManyWhereInput>;
  to?: Array<Stage>;
};


export type MutationUnpublishManyStatesArgs = {
  where?: Maybe<StateManyWhereInput>;
  from?: Array<Stage>;
};

/** An object with an ID */
export type Node = {
  /** The id of the object. */
  id: Scalars['ID'];
  /** The Stage of an object */
  stage: Stage;
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** Number of items in the current page. */
  pageSize?: Maybe<Scalars['Int']>;
};

/** The names ща the pages we support */
export enum PageName {
  CareLanding = 'CareLanding'
}

/** The text section to use on the page */
export type PageSection = Node & {
  __typename?: 'PageSection';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<PageSection>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  key: Scalars['String'];
  pageName: PageName;
  text?: Maybe<Scalars['String']>;
  /** List of PageSection versions */
  history: Array<Version>;
};


/** The text section to use on the page */
export type PageSectionDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


/** The text section to use on the page */
export type PageSectionCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** The text section to use on the page */
export type PageSectionUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** The text section to use on the page */
export type PageSectionPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


/** The text section to use on the page */
export type PageSectionHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type PageSectionConnectInput = {
  /** Document to connect */
  where: PageSectionWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type PageSectionConnection = {
  __typename?: 'PageSectionConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<PageSectionEdge>;
  aggregate: Aggregate;
};

export type PageSectionCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  key: Scalars['String'];
  pageName: PageName;
  text?: Maybe<Scalars['String']>;
};

export type PageSectionCreateManyInlineInput = {
  /** Create and connect multiple existing PageSection documents */
  create?: Maybe<Array<PageSectionCreateInput>>;
  /** Connect multiple existing PageSection documents */
  connect?: Maybe<Array<PageSectionWhereUniqueInput>>;
};

export type PageSectionCreateOneInlineInput = {
  /** Create and connect one PageSection document */
  create?: Maybe<PageSectionCreateInput>;
  /** Connect one existing PageSection document */
  connect?: Maybe<PageSectionWhereUniqueInput>;
};

/** An edge in a connection. */
export type PageSectionEdge = {
  __typename?: 'PageSectionEdge';
  /** The item at the end of the edge. */
  node: PageSection;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type PageSectionManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<PageSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<PageSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<PageSectionWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  key?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  key_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  key_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  key_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  key_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  key_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  key_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  key_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  key_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  key_not_ends_with?: Maybe<Scalars['String']>;
  pageName?: Maybe<PageName>;
  /** All values that are not equal to given value. */
  pageName_not?: Maybe<PageName>;
  /** All values that are contained in given list. */
  pageName_in?: Maybe<Array<PageName>>;
  /** All values that are not contained in given list. */
  pageName_not_in?: Maybe<Array<PageName>>;
  text?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  text_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  text_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  text_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  text_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  text_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  text_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  text_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  text_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  text_not_ends_with?: Maybe<Scalars['String']>;
};

export enum PageSectionOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  KeyAsc = 'key_ASC',
  KeyDesc = 'key_DESC',
  PageNameAsc = 'pageName_ASC',
  PageNameDesc = 'pageName_DESC',
  TextAsc = 'text_ASC',
  TextDesc = 'text_DESC'
}

export type PageSectionUpdateInput = {
  key?: Maybe<Scalars['String']>;
  pageName?: Maybe<PageName>;
  text?: Maybe<Scalars['String']>;
};

export type PageSectionUpdateManyInlineInput = {
  /** Create and connect multiple PageSection documents */
  create?: Maybe<Array<PageSectionCreateInput>>;
  /** Connect multiple existing PageSection documents */
  connect?: Maybe<Array<PageSectionConnectInput>>;
  /** Override currently-connected documents with multiple existing PageSection documents */
  set?: Maybe<Array<PageSectionWhereUniqueInput>>;
  /** Update multiple PageSection documents */
  update?: Maybe<Array<PageSectionUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple PageSection documents */
  upsert?: Maybe<Array<PageSectionUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple PageSection documents */
  disconnect?: Maybe<Array<PageSectionWhereUniqueInput>>;
  /** Delete multiple PageSection documents */
  delete?: Maybe<Array<PageSectionWhereUniqueInput>>;
};

export type PageSectionUpdateManyInput = {
  key?: Maybe<Scalars['String']>;
  pageName?: Maybe<PageName>;
  text?: Maybe<Scalars['String']>;
};

export type PageSectionUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: PageSectionWhereInput;
  /** Update many input */
  data: PageSectionUpdateManyInput;
};

export type PageSectionUpdateOneInlineInput = {
  /** Create and connect one PageSection document */
  create?: Maybe<PageSectionCreateInput>;
  /** Update single PageSection document */
  update?: Maybe<PageSectionUpdateWithNestedWhereUniqueInput>;
  /** Upsert single PageSection document */
  upsert?: Maybe<PageSectionUpsertWithNestedWhereUniqueInput>;
  /** Connect existing PageSection document */
  connect?: Maybe<PageSectionWhereUniqueInput>;
  /** Disconnect currently connected PageSection document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected PageSection document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type PageSectionUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: PageSectionWhereUniqueInput;
  /** Document to update */
  data: PageSectionUpdateInput;
};

export type PageSectionUpsertInput = {
  /** Create document if it didn't exist */
  create: PageSectionCreateInput;
  /** Update document if it exists */
  update: PageSectionUpdateInput;
};

export type PageSectionUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: PageSectionWhereUniqueInput;
  /** Upsert data */
  data: PageSectionUpsertInput;
};

/** Identifies documents */
export type PageSectionWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<PageSectionWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<PageSectionWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<PageSectionWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  key?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  key_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  key_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  key_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  key_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  key_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  key_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  key_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  key_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  key_not_ends_with?: Maybe<Scalars['String']>;
  pageName?: Maybe<PageName>;
  /** All values that are not equal to given value. */
  pageName_not?: Maybe<PageName>;
  /** All values that are contained in given list. */
  pageName_in?: Maybe<Array<PageName>>;
  /** All values that are not contained in given list. */
  pageName_not_in?: Maybe<Array<PageName>>;
  text?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  text_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  text_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  text_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  text_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  text_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  text_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  text_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  text_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  text_not_ends_with?: Maybe<Scalars['String']>;
};

/** References PageSection record uniquely */
export type PageSectionWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Provider = Node & {
  __typename?: 'Provider';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<Provider>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  type: ProviderType;
  name: Scalars['String'];
  degree?: Maybe<Scalars['String']>;
  /** used for provider page URL */
  slug: Scalars['String'];
  photo?: Maybe<Asset>;
  /** a brief description of the provider */
  about?: Maybe<Scalars['String']>;
  /** provider biography */
  bio?: Maybe<Scalars['String']>;
  educationalHistory?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  previousPositions?: Maybe<Scalars['String']>;
  mostLikelyToFindMe?: Maybe<Scalars['String']>;
  askMeAbout?: Maybe<Scalars['String']>;
  socialLinkedIn?: Maybe<Scalars['String']>;
  socialHealthgrades?: Maybe<Scalars['String']>;
  cities: Array<City>;
  /** will be displayed in Additional Information */
  links: Array<ProviderLink>;
  cityLeadProvider: Array<City>;
  /** If set to true, the provider is considered to be telehealth only */
  telehealth: Scalars['Boolean'];
  /** List of Provider versions */
  history: Array<Version>;
};


export type ProviderDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type ProviderCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ProviderUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ProviderPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ProviderPhotoArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ProviderCitiesArgs = {
  where?: Maybe<CityWhereInput>;
  orderBy?: Maybe<CityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type ProviderLinksArgs = {
  where?: Maybe<ProviderLinkWhereInput>;
  orderBy?: Maybe<ProviderLinkOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type ProviderCityLeadProviderArgs = {
  where?: Maybe<CityWhereInput>;
  orderBy?: Maybe<CityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type ProviderHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type ProviderConnectInput = {
  /** Document to connect */
  where: ProviderWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type ProviderConnection = {
  __typename?: 'ProviderConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<ProviderEdge>;
  aggregate: Aggregate;
};

export type ProviderCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  type: ProviderType;
  name: Scalars['String'];
  degree?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  photo?: Maybe<AssetCreateOneInlineInput>;
  about?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  educationalHistory?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  previousPositions?: Maybe<Scalars['String']>;
  mostLikelyToFindMe?: Maybe<Scalars['String']>;
  askMeAbout?: Maybe<Scalars['String']>;
  socialLinkedIn?: Maybe<Scalars['String']>;
  socialHealthgrades?: Maybe<Scalars['String']>;
  cities?: Maybe<CityCreateManyInlineInput>;
  links?: Maybe<ProviderLinkCreateManyInlineInput>;
  cityLeadProvider?: Maybe<CityCreateManyInlineInput>;
  telehealth: Scalars['Boolean'];
};

export type ProviderCreateManyInlineInput = {
  /** Create and connect multiple existing Provider documents */
  create?: Maybe<Array<ProviderCreateInput>>;
  /** Connect multiple existing Provider documents */
  connect?: Maybe<Array<ProviderWhereUniqueInput>>;
};

export type ProviderCreateOneInlineInput = {
  /** Create and connect one Provider document */
  create?: Maybe<ProviderCreateInput>;
  /** Connect one existing Provider document */
  connect?: Maybe<ProviderWhereUniqueInput>;
};

/** An edge in a connection. */
export type ProviderEdge = {
  __typename?: 'ProviderEdge';
  /** The item at the end of the edge. */
  node: Provider;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

export type ProviderLink = Node & {
  __typename?: 'ProviderLink';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<ProviderLink>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  provider?: Maybe<Provider>;
  type: ProviderLinkType;
  url: Scalars['String'];
  /** List of ProviderLink versions */
  history: Array<Version>;
};


export type ProviderLinkDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type ProviderLinkCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ProviderLinkUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ProviderLinkPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ProviderLinkProviderArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type ProviderLinkHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type ProviderLinkConnectInput = {
  /** Document to connect */
  where: ProviderLinkWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type ProviderLinkConnection = {
  __typename?: 'ProviderLinkConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<ProviderLinkEdge>;
  aggregate: Aggregate;
};

export type ProviderLinkCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  provider?: Maybe<ProviderCreateOneInlineInput>;
  type: ProviderLinkType;
  url: Scalars['String'];
};

export type ProviderLinkCreateManyInlineInput = {
  /** Create and connect multiple existing ProviderLink documents */
  create?: Maybe<Array<ProviderLinkCreateInput>>;
  /** Connect multiple existing ProviderLink documents */
  connect?: Maybe<Array<ProviderLinkWhereUniqueInput>>;
};

export type ProviderLinkCreateOneInlineInput = {
  /** Create and connect one ProviderLink document */
  create?: Maybe<ProviderLinkCreateInput>;
  /** Connect one existing ProviderLink document */
  connect?: Maybe<ProviderLinkWhereUniqueInput>;
};

/** An edge in a connection. */
export type ProviderLinkEdge = {
  __typename?: 'ProviderLinkEdge';
  /** The item at the end of the edge. */
  node: ProviderLink;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type ProviderLinkManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<ProviderLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<ProviderLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<ProviderLinkWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  provider?: Maybe<ProviderWhereInput>;
  type?: Maybe<ProviderLinkType>;
  /** All values that are not equal to given value. */
  type_not?: Maybe<ProviderLinkType>;
  /** All values that are contained in given list. */
  type_in?: Maybe<Array<ProviderLinkType>>;
  /** All values that are not contained in given list. */
  type_not_in?: Maybe<Array<ProviderLinkType>>;
  url?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  url_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  url_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  url_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  url_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  url_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  url_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  url_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  url_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  url_not_ends_with?: Maybe<Scalars['String']>;
};

export enum ProviderLinkOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  UrlAsc = 'url_ASC',
  UrlDesc = 'url_DESC'
}

export enum ProviderLinkType {
  Healthgrades = 'Healthgrades',
  LinkedIn = 'LinkedIn'
}

export type ProviderLinkUpdateInput = {
  provider?: Maybe<ProviderUpdateOneInlineInput>;
  type?: Maybe<ProviderLinkType>;
  url?: Maybe<Scalars['String']>;
};

export type ProviderLinkUpdateManyInlineInput = {
  /** Create and connect multiple ProviderLink documents */
  create?: Maybe<Array<ProviderLinkCreateInput>>;
  /** Connect multiple existing ProviderLink documents */
  connect?: Maybe<Array<ProviderLinkConnectInput>>;
  /** Override currently-connected documents with multiple existing ProviderLink documents */
  set?: Maybe<Array<ProviderLinkWhereUniqueInput>>;
  /** Update multiple ProviderLink documents */
  update?: Maybe<Array<ProviderLinkUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple ProviderLink documents */
  upsert?: Maybe<Array<ProviderLinkUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple ProviderLink documents */
  disconnect?: Maybe<Array<ProviderLinkWhereUniqueInput>>;
  /** Delete multiple ProviderLink documents */
  delete?: Maybe<Array<ProviderLinkWhereUniqueInput>>;
};

export type ProviderLinkUpdateManyInput = {
  type?: Maybe<ProviderLinkType>;
  url?: Maybe<Scalars['String']>;
};

export type ProviderLinkUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: ProviderLinkWhereInput;
  /** Update many input */
  data: ProviderLinkUpdateManyInput;
};

export type ProviderLinkUpdateOneInlineInput = {
  /** Create and connect one ProviderLink document */
  create?: Maybe<ProviderLinkCreateInput>;
  /** Update single ProviderLink document */
  update?: Maybe<ProviderLinkUpdateWithNestedWhereUniqueInput>;
  /** Upsert single ProviderLink document */
  upsert?: Maybe<ProviderLinkUpsertWithNestedWhereUniqueInput>;
  /** Connect existing ProviderLink document */
  connect?: Maybe<ProviderLinkWhereUniqueInput>;
  /** Disconnect currently connected ProviderLink document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected ProviderLink document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type ProviderLinkUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: ProviderLinkWhereUniqueInput;
  /** Document to update */
  data: ProviderLinkUpdateInput;
};

export type ProviderLinkUpsertInput = {
  /** Create document if it didn't exist */
  create: ProviderLinkCreateInput;
  /** Update document if it exists */
  update: ProviderLinkUpdateInput;
};

export type ProviderLinkUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: ProviderLinkWhereUniqueInput;
  /** Upsert data */
  data: ProviderLinkUpsertInput;
};

/** Identifies documents */
export type ProviderLinkWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<ProviderLinkWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<ProviderLinkWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<ProviderLinkWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  provider?: Maybe<ProviderWhereInput>;
  type?: Maybe<ProviderLinkType>;
  /** All values that are not equal to given value. */
  type_not?: Maybe<ProviderLinkType>;
  /** All values that are contained in given list. */
  type_in?: Maybe<Array<ProviderLinkType>>;
  /** All values that are not contained in given list. */
  type_not_in?: Maybe<Array<ProviderLinkType>>;
  url?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  url_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  url_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  url_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  url_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  url_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  url_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  url_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  url_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  url_not_ends_with?: Maybe<Scalars['String']>;
};

/** References ProviderLink record uniquely */
export type ProviderLinkWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

/** Identifies documents */
export type ProviderManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<ProviderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<ProviderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<ProviderWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  type?: Maybe<ProviderType>;
  /** All values that are not equal to given value. */
  type_not?: Maybe<ProviderType>;
  /** All values that are contained in given list. */
  type_in?: Maybe<Array<ProviderType>>;
  /** All values that are not contained in given list. */
  type_not_in?: Maybe<Array<ProviderType>>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  degree_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  degree_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  degree_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  degree_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  degree_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  degree_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  degree_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  degree_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  degree_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  photo?: Maybe<AssetWhereInput>;
  about?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  about_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  about_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  about_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  about_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  about_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  about_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  about_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  about_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  about_not_ends_with?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  bio_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bio_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  bio_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  bio_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  bio_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  bio_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  bio_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: Maybe<Scalars['String']>;
  educationalHistory?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  educationalHistory_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  educationalHistory_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  educationalHistory_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  educationalHistory_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  educationalHistory_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  educationalHistory_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  educationalHistory_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  educationalHistory_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  educationalHistory_not_ends_with?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  credentials_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  credentials_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  credentials_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  credentials_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  credentials_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  credentials_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  credentials_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  credentials_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  credentials_not_ends_with?: Maybe<Scalars['String']>;
  previousPositions?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  previousPositions_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  previousPositions_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  previousPositions_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  previousPositions_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  previousPositions_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  previousPositions_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  previousPositions_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  previousPositions_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  previousPositions_not_ends_with?: Maybe<Scalars['String']>;
  mostLikelyToFindMe?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  mostLikelyToFindMe_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  mostLikelyToFindMe_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  mostLikelyToFindMe_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  mostLikelyToFindMe_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  mostLikelyToFindMe_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  mostLikelyToFindMe_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  mostLikelyToFindMe_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  mostLikelyToFindMe_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  mostLikelyToFindMe_not_ends_with?: Maybe<Scalars['String']>;
  askMeAbout?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  askMeAbout_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  askMeAbout_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  askMeAbout_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  askMeAbout_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  askMeAbout_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  askMeAbout_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  askMeAbout_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  askMeAbout_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  askMeAbout_not_ends_with?: Maybe<Scalars['String']>;
  socialLinkedIn?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  socialLinkedIn_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  socialLinkedIn_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  socialLinkedIn_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  socialLinkedIn_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  socialLinkedIn_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  socialLinkedIn_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  socialLinkedIn_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  socialLinkedIn_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  socialLinkedIn_not_ends_with?: Maybe<Scalars['String']>;
  socialHealthgrades?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  socialHealthgrades_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  socialHealthgrades_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  socialHealthgrades_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  socialHealthgrades_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  socialHealthgrades_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  socialHealthgrades_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  socialHealthgrades_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  socialHealthgrades_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  socialHealthgrades_not_ends_with?: Maybe<Scalars['String']>;
  cities_every?: Maybe<CityWhereInput>;
  cities_some?: Maybe<CityWhereInput>;
  cities_none?: Maybe<CityWhereInput>;
  links_every?: Maybe<ProviderLinkWhereInput>;
  links_some?: Maybe<ProviderLinkWhereInput>;
  links_none?: Maybe<ProviderLinkWhereInput>;
  cityLeadProvider_every?: Maybe<CityWhereInput>;
  cityLeadProvider_some?: Maybe<CityWhereInput>;
  cityLeadProvider_none?: Maybe<CityWhereInput>;
  telehealth?: Maybe<Scalars['Boolean']>;
  /** All values that are not equal to given value. */
  telehealth_not?: Maybe<Scalars['Boolean']>;
};

export enum ProviderOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TypeAsc = 'type_ASC',
  TypeDesc = 'type_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  DegreeAsc = 'degree_ASC',
  DegreeDesc = 'degree_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  AboutAsc = 'about_ASC',
  AboutDesc = 'about_DESC',
  BioAsc = 'bio_ASC',
  BioDesc = 'bio_DESC',
  EducationalHistoryAsc = 'educationalHistory_ASC',
  EducationalHistoryDesc = 'educationalHistory_DESC',
  CredentialsAsc = 'credentials_ASC',
  CredentialsDesc = 'credentials_DESC',
  PreviousPositionsAsc = 'previousPositions_ASC',
  PreviousPositionsDesc = 'previousPositions_DESC',
  MostLikelyToFindMeAsc = 'mostLikelyToFindMe_ASC',
  MostLikelyToFindMeDesc = 'mostLikelyToFindMe_DESC',
  AskMeAboutAsc = 'askMeAbout_ASC',
  AskMeAboutDesc = 'askMeAbout_DESC',
  SocialLinkedInAsc = 'socialLinkedIn_ASC',
  SocialLinkedInDesc = 'socialLinkedIn_DESC',
  SocialHealthgradesAsc = 'socialHealthgrades_ASC',
  SocialHealthgradesDesc = 'socialHealthgrades_DESC',
  TelehealthAsc = 'telehealth_ASC',
  TelehealthDesc = 'telehealth_DESC'
}

export enum ProviderType {
  Diagnostician = 'Diagnostician',
  Therapist = 'Therapist'
}

export type ProviderUpdateInput = {
  type?: Maybe<ProviderType>;
  name?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  photo?: Maybe<AssetUpdateOneInlineInput>;
  about?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  educationalHistory?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  previousPositions?: Maybe<Scalars['String']>;
  mostLikelyToFindMe?: Maybe<Scalars['String']>;
  askMeAbout?: Maybe<Scalars['String']>;
  socialLinkedIn?: Maybe<Scalars['String']>;
  socialHealthgrades?: Maybe<Scalars['String']>;
  cities?: Maybe<CityUpdateManyInlineInput>;
  links?: Maybe<ProviderLinkUpdateManyInlineInput>;
  cityLeadProvider?: Maybe<CityUpdateManyInlineInput>;
  telehealth?: Maybe<Scalars['Boolean']>;
};

export type ProviderUpdateManyInlineInput = {
  /** Create and connect multiple Provider documents */
  create?: Maybe<Array<ProviderCreateInput>>;
  /** Connect multiple existing Provider documents */
  connect?: Maybe<Array<ProviderConnectInput>>;
  /** Override currently-connected documents with multiple existing Provider documents */
  set?: Maybe<Array<ProviderWhereUniqueInput>>;
  /** Update multiple Provider documents */
  update?: Maybe<Array<ProviderUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple Provider documents */
  upsert?: Maybe<Array<ProviderUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple Provider documents */
  disconnect?: Maybe<Array<ProviderWhereUniqueInput>>;
  /** Delete multiple Provider documents */
  delete?: Maybe<Array<ProviderWhereUniqueInput>>;
};

export type ProviderUpdateManyInput = {
  type?: Maybe<ProviderType>;
  name?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  educationalHistory?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  previousPositions?: Maybe<Scalars['String']>;
  mostLikelyToFindMe?: Maybe<Scalars['String']>;
  askMeAbout?: Maybe<Scalars['String']>;
  socialLinkedIn?: Maybe<Scalars['String']>;
  socialHealthgrades?: Maybe<Scalars['String']>;
  telehealth?: Maybe<Scalars['Boolean']>;
};

export type ProviderUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: ProviderWhereInput;
  /** Update many input */
  data: ProviderUpdateManyInput;
};

export type ProviderUpdateOneInlineInput = {
  /** Create and connect one Provider document */
  create?: Maybe<ProviderCreateInput>;
  /** Update single Provider document */
  update?: Maybe<ProviderUpdateWithNestedWhereUniqueInput>;
  /** Upsert single Provider document */
  upsert?: Maybe<ProviderUpsertWithNestedWhereUniqueInput>;
  /** Connect existing Provider document */
  connect?: Maybe<ProviderWhereUniqueInput>;
  /** Disconnect currently connected Provider document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected Provider document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type ProviderUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: ProviderWhereUniqueInput;
  /** Document to update */
  data: ProviderUpdateInput;
};

export type ProviderUpsertInput = {
  /** Create document if it didn't exist */
  create: ProviderCreateInput;
  /** Update document if it exists */
  update: ProviderUpdateInput;
};

export type ProviderUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: ProviderWhereUniqueInput;
  /** Upsert data */
  data: ProviderUpsertInput;
};

/** Identifies documents */
export type ProviderWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<ProviderWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<ProviderWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<ProviderWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  type?: Maybe<ProviderType>;
  /** All values that are not equal to given value. */
  type_not?: Maybe<ProviderType>;
  /** All values that are contained in given list. */
  type_in?: Maybe<Array<ProviderType>>;
  /** All values that are not contained in given list. */
  type_not_in?: Maybe<Array<ProviderType>>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  degree?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  degree_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  degree_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  degree_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  degree_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  degree_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  degree_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  degree_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  degree_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  degree_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  photo?: Maybe<AssetWhereInput>;
  about?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  about_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  about_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  about_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  about_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  about_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  about_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  about_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  about_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  about_not_ends_with?: Maybe<Scalars['String']>;
  bio?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  bio_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  bio_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  bio_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  bio_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  bio_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  bio_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  bio_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  bio_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  bio_not_ends_with?: Maybe<Scalars['String']>;
  educationalHistory?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  educationalHistory_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  educationalHistory_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  educationalHistory_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  educationalHistory_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  educationalHistory_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  educationalHistory_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  educationalHistory_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  educationalHistory_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  educationalHistory_not_ends_with?: Maybe<Scalars['String']>;
  credentials?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  credentials_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  credentials_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  credentials_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  credentials_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  credentials_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  credentials_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  credentials_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  credentials_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  credentials_not_ends_with?: Maybe<Scalars['String']>;
  previousPositions?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  previousPositions_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  previousPositions_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  previousPositions_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  previousPositions_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  previousPositions_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  previousPositions_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  previousPositions_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  previousPositions_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  previousPositions_not_ends_with?: Maybe<Scalars['String']>;
  mostLikelyToFindMe?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  mostLikelyToFindMe_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  mostLikelyToFindMe_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  mostLikelyToFindMe_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  mostLikelyToFindMe_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  mostLikelyToFindMe_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  mostLikelyToFindMe_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  mostLikelyToFindMe_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  mostLikelyToFindMe_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  mostLikelyToFindMe_not_ends_with?: Maybe<Scalars['String']>;
  askMeAbout?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  askMeAbout_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  askMeAbout_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  askMeAbout_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  askMeAbout_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  askMeAbout_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  askMeAbout_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  askMeAbout_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  askMeAbout_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  askMeAbout_not_ends_with?: Maybe<Scalars['String']>;
  socialLinkedIn?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  socialLinkedIn_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  socialLinkedIn_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  socialLinkedIn_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  socialLinkedIn_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  socialLinkedIn_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  socialLinkedIn_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  socialLinkedIn_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  socialLinkedIn_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  socialLinkedIn_not_ends_with?: Maybe<Scalars['String']>;
  socialHealthgrades?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  socialHealthgrades_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  socialHealthgrades_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  socialHealthgrades_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  socialHealthgrades_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  socialHealthgrades_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  socialHealthgrades_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  socialHealthgrades_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  socialHealthgrades_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  socialHealthgrades_not_ends_with?: Maybe<Scalars['String']>;
  cities_every?: Maybe<CityWhereInput>;
  cities_some?: Maybe<CityWhereInput>;
  cities_none?: Maybe<CityWhereInput>;
  links_every?: Maybe<ProviderLinkWhereInput>;
  links_some?: Maybe<ProviderLinkWhereInput>;
  links_none?: Maybe<ProviderLinkWhereInput>;
  cityLeadProvider_every?: Maybe<CityWhereInput>;
  cityLeadProvider_some?: Maybe<CityWhereInput>;
  cityLeadProvider_none?: Maybe<CityWhereInput>;
  telehealth?: Maybe<Scalars['Boolean']>;
  /** All values that are not equal to given value. */
  telehealth_not?: Maybe<Scalars['Boolean']>;
};

/** References Provider record uniquely */
export type ProviderWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  slug?: Maybe<Scalars['String']>;
};

export type PublishLocaleInput = {
  /** Locales to publish */
  locale: Locale;
  /** Stages to publish selected locales to */
  stages: Array<Stage>;
};

export type Query = {
  __typename?: 'Query';
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Retrieve multiple assets */
  assets: Array<Asset>;
  /** Retrieve a single asset */
  asset?: Maybe<Asset>;
  /** Retrieve multiple assets using the Relay connection interface */
  assetsConnection: AssetConnection;
  /** Retrieve document version */
  assetVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple authors */
  authors: Array<Author>;
  /** Retrieve a single author */
  author?: Maybe<Author>;
  /** Retrieve multiple authors using the Relay connection interface */
  authorsConnection: AuthorConnection;
  /** Retrieve document version */
  authorVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple blogParents */
  blogParents: Array<BlogParent>;
  /** Retrieve a single blogParent */
  blogParent?: Maybe<BlogParent>;
  /** Retrieve multiple blogParents using the Relay connection interface */
  blogParentsConnection: BlogParentConnection;
  /** Retrieve document version */
  blogParentVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple blogPosts */
  blogPosts: Array<BlogPost>;
  /** Retrieve a single blogPost */
  blogPost?: Maybe<BlogPost>;
  /** Retrieve multiple blogPosts using the Relay connection interface */
  blogPostsConnection: BlogPostConnection;
  /** Retrieve document version */
  blogPostVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple bookingLearnMoreAboutAutismGroups */
  bookingLearnMoreAboutAutismGroups: Array<BookingLearnMoreAboutAutismGroup>;
  /** Retrieve a single bookingLearnMoreAboutAutismGroup */
  bookingLearnMoreAboutAutismGroup?: Maybe<BookingLearnMoreAboutAutismGroup>;
  /** Retrieve multiple bookingLearnMoreAboutAutismGroups using the Relay connection interface */
  bookingLearnMoreAboutAutismGroupsConnection: BookingLearnMoreAboutAutismGroupConnection;
  /** Retrieve document version */
  bookingLearnMoreAboutAutismGroupVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple cities */
  cities: Array<City>;
  /** Retrieve a single city */
  city?: Maybe<City>;
  /** Retrieve multiple cities using the Relay connection interface */
  citiesConnection: CityConnection;
  /** Retrieve document version */
  cityVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple clinics */
  clinics: Array<Clinic>;
  /** Retrieve a single clinic */
  clinic?: Maybe<Clinic>;
  /** Retrieve multiple clinics using the Relay connection interface */
  clinicsConnection: ClinicConnection;
  /** Retrieve document version */
  clinicVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple joinSproutTherapyHomePages */
  joinSproutTherapyHomePages: Array<JoinSproutTherapyHomePage>;
  /** Retrieve a single joinSproutTherapyHomePage */
  joinSproutTherapyHomePage?: Maybe<JoinSproutTherapyHomePage>;
  /** Retrieve multiple joinSproutTherapyHomePages using the Relay connection interface */
  joinSproutTherapyHomePagesConnection: JoinSproutTherapyHomePageConnection;
  /** Retrieve document version */
  joinSproutTherapyHomePageVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple pageSections */
  pageSections: Array<PageSection>;
  /** Retrieve a single pageSection */
  pageSection?: Maybe<PageSection>;
  /** Retrieve multiple pageSections using the Relay connection interface */
  pageSectionsConnection: PageSectionConnection;
  /** Retrieve document version */
  pageSectionVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple providers */
  providers: Array<Provider>;
  /** Retrieve a single provider */
  provider?: Maybe<Provider>;
  /** Retrieve multiple providers using the Relay connection interface */
  providersConnection: ProviderConnection;
  /** Retrieve document version */
  providerVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple providerLinks */
  providerLinks: Array<ProviderLink>;
  /** Retrieve a single providerLink */
  providerLink?: Maybe<ProviderLink>;
  /** Retrieve multiple providerLinks using the Relay connection interface */
  providerLinksConnection: ProviderLinkConnection;
  /** Retrieve document version */
  providerLinkVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple seoDataItems */
  seoDataItems: Array<SeoDataItem>;
  /** Retrieve a single seoDataItem */
  seoDataItem?: Maybe<SeoDataItem>;
  /** Retrieve multiple seoDataItems using the Relay connection interface */
  seoDataItemsConnection: SeoDataItemConnection;
  /** Retrieve document version */
  seoDataItemVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple states */
  states: Array<State>;
  /** Retrieve a single state */
  state?: Maybe<State>;
  /** Retrieve multiple states using the Relay connection interface */
  statesConnection: StateConnection;
  /** Retrieve document version */
  stateVersion?: Maybe<DocumentVersion>;
  /** Retrieve multiple users */
  users: Array<User>;
  /** Retrieve a single user */
  user?: Maybe<User>;
  /** Retrieve multiple users using the Relay connection interface */
  usersConnection: UserConnection;
};


export type QueryNodeArgs = {
  id: Scalars['ID'];
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryAssetsArgs = {
  where?: Maybe<AssetWhereInput>;
  orderBy?: Maybe<AssetOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryAssetArgs = {
  where: AssetWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryAssetsConnectionArgs = {
  where?: Maybe<AssetWhereInput>;
  orderBy?: Maybe<AssetOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryAssetVersionArgs = {
  where: VersionWhereInput;
};


export type QueryAuthorsArgs = {
  where?: Maybe<AuthorWhereInput>;
  orderBy?: Maybe<AuthorOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryAuthorArgs = {
  where: AuthorWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryAuthorsConnectionArgs = {
  where?: Maybe<AuthorWhereInput>;
  orderBy?: Maybe<AuthorOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryAuthorVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBlogParentsArgs = {
  where?: Maybe<BlogParentWhereInput>;
  orderBy?: Maybe<BlogParentOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBlogParentArgs = {
  where: BlogParentWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBlogParentsConnectionArgs = {
  where?: Maybe<BlogParentWhereInput>;
  orderBy?: Maybe<BlogParentOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBlogParentVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBlogPostsArgs = {
  where?: Maybe<BlogPostWhereInput>;
  orderBy?: Maybe<BlogPostOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBlogPostArgs = {
  where: BlogPostWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBlogPostsConnectionArgs = {
  where?: Maybe<BlogPostWhereInput>;
  orderBy?: Maybe<BlogPostOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBlogPostVersionArgs = {
  where: VersionWhereInput;
};


export type QueryBookingLearnMoreAboutAutismGroupsArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
  orderBy?: Maybe<BookingLearnMoreAboutAutismGroupOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBookingLearnMoreAboutAutismGroupArgs = {
  where: BookingLearnMoreAboutAutismGroupWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBookingLearnMoreAboutAutismGroupsConnectionArgs = {
  where?: Maybe<BookingLearnMoreAboutAutismGroupWhereInput>;
  orderBy?: Maybe<BookingLearnMoreAboutAutismGroupOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryBookingLearnMoreAboutAutismGroupVersionArgs = {
  where: VersionWhereInput;
};


export type QueryCitiesArgs = {
  where?: Maybe<CityWhereInput>;
  orderBy?: Maybe<CityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryCityArgs = {
  where: CityWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryCitiesConnectionArgs = {
  where?: Maybe<CityWhereInput>;
  orderBy?: Maybe<CityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryCityVersionArgs = {
  where: VersionWhereInput;
};


export type QueryClinicsArgs = {
  where?: Maybe<ClinicWhereInput>;
  orderBy?: Maybe<ClinicOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryClinicArgs = {
  where: ClinicWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryClinicsConnectionArgs = {
  where?: Maybe<ClinicWhereInput>;
  orderBy?: Maybe<ClinicOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryClinicVersionArgs = {
  where: VersionWhereInput;
};


export type QueryJoinSproutTherapyHomePagesArgs = {
  where?: Maybe<JoinSproutTherapyHomePageWhereInput>;
  orderBy?: Maybe<JoinSproutTherapyHomePageOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryJoinSproutTherapyHomePageArgs = {
  where: JoinSproutTherapyHomePageWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryJoinSproutTherapyHomePagesConnectionArgs = {
  where?: Maybe<JoinSproutTherapyHomePageWhereInput>;
  orderBy?: Maybe<JoinSproutTherapyHomePageOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryJoinSproutTherapyHomePageVersionArgs = {
  where: VersionWhereInput;
};


export type QueryPageSectionsArgs = {
  where?: Maybe<PageSectionWhereInput>;
  orderBy?: Maybe<PageSectionOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryPageSectionArgs = {
  where: PageSectionWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryPageSectionsConnectionArgs = {
  where?: Maybe<PageSectionWhereInput>;
  orderBy?: Maybe<PageSectionOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryPageSectionVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProvidersArgs = {
  where?: Maybe<ProviderWhereInput>;
  orderBy?: Maybe<ProviderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryProviderArgs = {
  where: ProviderWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryProvidersConnectionArgs = {
  where?: Maybe<ProviderWhereInput>;
  orderBy?: Maybe<ProviderOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryProviderVersionArgs = {
  where: VersionWhereInput;
};


export type QueryProviderLinksArgs = {
  where?: Maybe<ProviderLinkWhereInput>;
  orderBy?: Maybe<ProviderLinkOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryProviderLinkArgs = {
  where: ProviderLinkWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryProviderLinksConnectionArgs = {
  where?: Maybe<ProviderLinkWhereInput>;
  orderBy?: Maybe<ProviderLinkOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryProviderLinkVersionArgs = {
  where: VersionWhereInput;
};


export type QuerySeoDataItemsArgs = {
  where?: Maybe<SeoDataItemWhereInput>;
  orderBy?: Maybe<SeoDataItemOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QuerySeoDataItemArgs = {
  where: SeoDataItemWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QuerySeoDataItemsConnectionArgs = {
  where?: Maybe<SeoDataItemWhereInput>;
  orderBy?: Maybe<SeoDataItemOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QuerySeoDataItemVersionArgs = {
  where: VersionWhereInput;
};


export type QueryStatesArgs = {
  where?: Maybe<StateWhereInput>;
  orderBy?: Maybe<StateOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryStateArgs = {
  where: StateWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryStatesConnectionArgs = {
  where?: Maybe<StateWhereInput>;
  orderBy?: Maybe<StateOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryStateVersionArgs = {
  where: VersionWhereInput;
};


export type QueryUsersArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<UserOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
  stage?: Stage;
  locales?: Array<Locale>;
};


export type QueryUsersConnectionArgs = {
  where?: Maybe<UserWhereInput>;
  orderBy?: Maybe<UserOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  stage?: Stage;
  locales?: Array<Locale>;
};

/** Representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type Rgba = {
  __typename?: 'RGBA';
  r: Scalars['RGBAHue'];
  g: Scalars['RGBAHue'];
  b: Scalars['RGBAHue'];
  a: Scalars['RGBATransparency'];
};


/** Input type representing a RGBA color value: https://developer.mozilla.org/en-US/docs/Web/CSS/color_value#rgb()_and_rgba() */
export type RgbaInput = {
  r: Scalars['RGBAHue'];
  g: Scalars['RGBAHue'];
  b: Scalars['RGBAHue'];
  a: Scalars['RGBATransparency'];
};


/** Custom type representing a rich text value comprising of raw rich text ast, html, markdown and text values */
export type RichText = {
  __typename?: 'RichText';
  /** Returns AST representation */
  raw: Scalars['RichTextAST'];
  /** Returns HTMl representation */
  html: Scalars['String'];
  /** Returns Markdown representation */
  markdown: Scalars['String'];
  /** Returns plain-text contents of RichText */
  text: Scalars['String'];
};


export type SeoDataItem = Node & {
  __typename?: 'SeoDataItem';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<SeoDataItem>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  title?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  blogPost?: Maybe<BlogPost>;
  /** List of SeoDataItem versions */
  history: Array<Version>;
};


export type SeoDataItemDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type SeoDataItemCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type SeoDataItemUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type SeoDataItemPublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type SeoDataItemBlogPostArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type SeoDataItemHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type SeoDataItemConnectInput = {
  /** Document to connect */
  where: SeoDataItemWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type SeoDataItemConnection = {
  __typename?: 'SeoDataItemConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<SeoDataItemEdge>;
  aggregate: Aggregate;
};

export type SeoDataItemCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  blogPost?: Maybe<BlogPostCreateOneInlineInput>;
};

export type SeoDataItemCreateManyInlineInput = {
  /** Create and connect multiple existing SeoDataItem documents */
  create?: Maybe<Array<SeoDataItemCreateInput>>;
  /** Connect multiple existing SeoDataItem documents */
  connect?: Maybe<Array<SeoDataItemWhereUniqueInput>>;
};

export type SeoDataItemCreateOneInlineInput = {
  /** Create and connect one SeoDataItem document */
  create?: Maybe<SeoDataItemCreateInput>;
  /** Connect one existing SeoDataItem document */
  connect?: Maybe<SeoDataItemWhereUniqueInput>;
};

/** An edge in a connection. */
export type SeoDataItemEdge = {
  __typename?: 'SeoDataItemEdge';
  /** The item at the end of the edge. */
  node: SeoDataItem;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type SeoDataItemManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<SeoDataItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<SeoDataItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<SeoDataItemWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  title?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  keywords_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  keywords_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  keywords_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  keywords_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  keywords_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  keywords_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  keywords_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  keywords_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  keywords_not_ends_with?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  description_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  description_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  description_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  description_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: Maybe<Scalars['String']>;
  blogPost?: Maybe<BlogPostWhereInput>;
};

export enum SeoDataItemOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  TitleAsc = 'title_ASC',
  TitleDesc = 'title_DESC',
  KeywordsAsc = 'keywords_ASC',
  KeywordsDesc = 'keywords_DESC',
  DescriptionAsc = 'description_ASC',
  DescriptionDesc = 'description_DESC'
}

export type SeoDataItemUpdateInput = {
  title?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  blogPost?: Maybe<BlogPostUpdateOneInlineInput>;
};

export type SeoDataItemUpdateManyInlineInput = {
  /** Create and connect multiple SeoDataItem documents */
  create?: Maybe<Array<SeoDataItemCreateInput>>;
  /** Connect multiple existing SeoDataItem documents */
  connect?: Maybe<Array<SeoDataItemConnectInput>>;
  /** Override currently-connected documents with multiple existing SeoDataItem documents */
  set?: Maybe<Array<SeoDataItemWhereUniqueInput>>;
  /** Update multiple SeoDataItem documents */
  update?: Maybe<Array<SeoDataItemUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple SeoDataItem documents */
  upsert?: Maybe<Array<SeoDataItemUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple SeoDataItem documents */
  disconnect?: Maybe<Array<SeoDataItemWhereUniqueInput>>;
  /** Delete multiple SeoDataItem documents */
  delete?: Maybe<Array<SeoDataItemWhereUniqueInput>>;
};

export type SeoDataItemUpdateManyInput = {
  title?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
};

export type SeoDataItemUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: SeoDataItemWhereInput;
  /** Update many input */
  data: SeoDataItemUpdateManyInput;
};

export type SeoDataItemUpdateOneInlineInput = {
  /** Create and connect one SeoDataItem document */
  create?: Maybe<SeoDataItemCreateInput>;
  /** Update single SeoDataItem document */
  update?: Maybe<SeoDataItemUpdateWithNestedWhereUniqueInput>;
  /** Upsert single SeoDataItem document */
  upsert?: Maybe<SeoDataItemUpsertWithNestedWhereUniqueInput>;
  /** Connect existing SeoDataItem document */
  connect?: Maybe<SeoDataItemWhereUniqueInput>;
  /** Disconnect currently connected SeoDataItem document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected SeoDataItem document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type SeoDataItemUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: SeoDataItemWhereUniqueInput;
  /** Document to update */
  data: SeoDataItemUpdateInput;
};

export type SeoDataItemUpsertInput = {
  /** Create document if it didn't exist */
  create: SeoDataItemCreateInput;
  /** Update document if it exists */
  update: SeoDataItemUpdateInput;
};

export type SeoDataItemUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: SeoDataItemWhereUniqueInput;
  /** Upsert data */
  data: SeoDataItemUpsertInput;
};

/** Identifies documents */
export type SeoDataItemWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<SeoDataItemWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<SeoDataItemWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<SeoDataItemWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  title?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  title_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  title_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  title_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  title_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  title_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  title_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  title_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  title_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  title_not_ends_with?: Maybe<Scalars['String']>;
  keywords?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  keywords_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  keywords_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  keywords_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  keywords_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  keywords_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  keywords_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  keywords_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  keywords_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  keywords_not_ends_with?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  description_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  description_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  description_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  description_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  description_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  description_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  description_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  description_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  description_not_ends_with?: Maybe<Scalars['String']>;
  blogPost?: Maybe<BlogPostWhereInput>;
};

/** References SeoDataItem record uniquely */
export type SeoDataItemWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

/** Stage system enumeration */
export enum Stage {
  /** The Published stage is where you can publish your content to. */
  Published = 'PUBLISHED',
  /** The Draft is the default stage for all your content. */
  Draft = 'DRAFT'
}

export type State = Node & {
  __typename?: 'State';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<State>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** User that created this document */
  createdBy?: Maybe<User>;
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** User that last updated this document */
  updatedBy?: Maybe<User>;
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** User that last published this document */
  publishedBy?: Maybe<User>;
  name: Scalars['String'];
  /** state code */
  code: Scalars['String'];
  /** used for state page URL */
  slug: Scalars['String'];
  about?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Asset>;
  cities: Array<City>;
  mapImage?: Maybe<Asset>;
  /** List of State versions */
  history: Array<Version>;
};


export type StateDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};


export type StateCreatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type StateUpdatedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type StatePublishedByArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type StateCoverImageArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type StateCitiesArgs = {
  where?: Maybe<CityWhereInput>;
  orderBy?: Maybe<CityOrderByInput>;
  skip?: Maybe<Scalars['Int']>;
  after?: Maybe<Scalars['String']>;
  before?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['Int']>;
  last?: Maybe<Scalars['Int']>;
  locales?: Maybe<Array<Locale>>;
};


export type StateMapImageArgs = {
  locales?: Maybe<Array<Locale>>;
};


export type StateHistoryArgs = {
  limit?: Scalars['Int'];
  skip?: Scalars['Int'];
  stageOverride?: Maybe<Stage>;
};

export type StateConnectInput = {
  /** Document to connect */
  where: StateWhereUniqueInput;
  /** Allow to specify document position in list of connected documents, will default to appending at end of list */
  position?: Maybe<ConnectPositionInput>;
};

/** A connection to a list of items. */
export type StateConnection = {
  __typename?: 'StateConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<StateEdge>;
  aggregate: Aggregate;
};

export type StateCreateInput = {
  createdAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  name: Scalars['String'];
  code: Scalars['String'];
  slug: Scalars['String'];
  about?: Maybe<Scalars['String']>;
  coverImage?: Maybe<AssetCreateOneInlineInput>;
  cities?: Maybe<CityCreateManyInlineInput>;
  mapImage?: Maybe<AssetCreateOneInlineInput>;
};

export type StateCreateManyInlineInput = {
  /** Create and connect multiple existing State documents */
  create?: Maybe<Array<StateCreateInput>>;
  /** Connect multiple existing State documents */
  connect?: Maybe<Array<StateWhereUniqueInput>>;
};

export type StateCreateOneInlineInput = {
  /** Create and connect one State document */
  create?: Maybe<StateCreateInput>;
  /** Connect one existing State document */
  connect?: Maybe<StateWhereUniqueInput>;
};

/** An edge in a connection. */
export type StateEdge = {
  __typename?: 'StateEdge';
  /** The item at the end of the edge. */
  node: State;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** Identifies documents */
export type StateManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<StateWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<StateWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<StateWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  code_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  code_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  code_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  code_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  code_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  code_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  code_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  code_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  code_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  about_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  about_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  about_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  about_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  about_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  about_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  about_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  about_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  about_not_ends_with?: Maybe<Scalars['String']>;
  coverImage?: Maybe<AssetWhereInput>;
  cities_every?: Maybe<CityWhereInput>;
  cities_some?: Maybe<CityWhereInput>;
  cities_none?: Maybe<CityWhereInput>;
  mapImage?: Maybe<AssetWhereInput>;
};

export enum StateOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  CodeAsc = 'code_ASC',
  CodeDesc = 'code_DESC',
  SlugAsc = 'slug_ASC',
  SlugDesc = 'slug_DESC',
  AboutAsc = 'about_ASC',
  AboutDesc = 'about_DESC'
}

export type StateUpdateInput = {
  name?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  coverImage?: Maybe<AssetUpdateOneInlineInput>;
  cities?: Maybe<CityUpdateManyInlineInput>;
  mapImage?: Maybe<AssetUpdateOneInlineInput>;
};

export type StateUpdateManyInlineInput = {
  /** Create and connect multiple State documents */
  create?: Maybe<Array<StateCreateInput>>;
  /** Connect multiple existing State documents */
  connect?: Maybe<Array<StateConnectInput>>;
  /** Override currently-connected documents with multiple existing State documents */
  set?: Maybe<Array<StateWhereUniqueInput>>;
  /** Update multiple State documents */
  update?: Maybe<Array<StateUpdateWithNestedWhereUniqueInput>>;
  /** Upsert multiple State documents */
  upsert?: Maybe<Array<StateUpsertWithNestedWhereUniqueInput>>;
  /** Disconnect multiple State documents */
  disconnect?: Maybe<Array<StateWhereUniqueInput>>;
  /** Delete multiple State documents */
  delete?: Maybe<Array<StateWhereUniqueInput>>;
};

export type StateUpdateManyInput = {
  code?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
};

export type StateUpdateManyWithNestedWhereInput = {
  /** Document search */
  where: StateWhereInput;
  /** Update many input */
  data: StateUpdateManyInput;
};

export type StateUpdateOneInlineInput = {
  /** Create and connect one State document */
  create?: Maybe<StateCreateInput>;
  /** Update single State document */
  update?: Maybe<StateUpdateWithNestedWhereUniqueInput>;
  /** Upsert single State document */
  upsert?: Maybe<StateUpsertWithNestedWhereUniqueInput>;
  /** Connect existing State document */
  connect?: Maybe<StateWhereUniqueInput>;
  /** Disconnect currently connected State document */
  disconnect?: Maybe<Scalars['Boolean']>;
  /** Delete currently connected State document */
  delete?: Maybe<Scalars['Boolean']>;
};

export type StateUpdateWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: StateWhereUniqueInput;
  /** Document to update */
  data: StateUpdateInput;
};

export type StateUpsertInput = {
  /** Create document if it didn't exist */
  create: StateCreateInput;
  /** Update document if it exists */
  update: StateUpdateInput;
};

export type StateUpsertWithNestedWhereUniqueInput = {
  /** Unique document search */
  where: StateWhereUniqueInput;
  /** Upsert data */
  data: StateUpsertInput;
};

/** Identifies documents */
export type StateWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<StateWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<StateWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<StateWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<UserWhereInput>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  updatedBy?: Maybe<UserWhereInput>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedBy?: Maybe<UserWhereInput>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  code_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  code_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  code_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  code_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  code_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  code_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  code_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  code_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  code_not_ends_with?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  slug_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  slug_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  slug_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  slug_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  slug_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  slug_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  slug_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  slug_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  slug_not_ends_with?: Maybe<Scalars['String']>;
  about?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  about_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  about_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  about_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  about_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  about_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  about_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  about_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  about_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  about_not_ends_with?: Maybe<Scalars['String']>;
  coverImage?: Maybe<AssetWhereInput>;
  cities_every?: Maybe<CityWhereInput>;
  cities_some?: Maybe<CityWhereInput>;
  cities_none?: Maybe<CityWhereInput>;
  mapImage?: Maybe<AssetWhereInput>;
};

/** References State record uniquely */
export type StateWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  slug?: Maybe<Scalars['String']>;
};

export enum SystemDateTimeFieldVariation {
  Base = 'BASE',
  Localization = 'LOCALIZATION',
  Combined = 'COMBINED'
}

export type UnpublishLocaleInput = {
  /** Locales to unpublish */
  locale: Locale;
  /** Stages to unpublish selected locales from */
  stages: Array<Stage>;
};

/** User system model */
export type User = Node & {
  __typename?: 'User';
  /** System stage field */
  stage: Stage;
  /** Get the document in other stages */
  documentInStages: Array<User>;
  /** The unique identifier */
  id: Scalars['ID'];
  /** The time the document was created */
  createdAt: Scalars['DateTime'];
  /** The time the document was updated */
  updatedAt: Scalars['DateTime'];
  /** The time the document was published. Null on documents in draft stage. */
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** The username */
  name: Scalars['String'];
  /** Profile Picture url */
  picture?: Maybe<Scalars['String']>;
  /** User Kind. Can be either MEMBER, PAT or PUBLIC */
  kind: UserKind;
  /** Flag to determine if user is active or not */
  isActive: Scalars['Boolean'];
};


/** User system model */
export type UserDocumentInStagesArgs = {
  stages?: Array<Stage>;
  includeCurrent?: Scalars['Boolean'];
  inheritLocale?: Scalars['Boolean'];
};

/** A connection to a list of items. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** A list of edges. */
  edges: Array<UserEdge>;
  aggregate: Aggregate;
};

/** An edge in a connection. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** The item at the end of the edge. */
  node: User;
  /** A cursor for use in pagination. */
  cursor: Scalars['String'];
};

/** System User Kind */
export enum UserKind {
  Member = 'MEMBER',
  Pat = 'PAT',
  Public = 'PUBLIC',
  Webhook = 'WEBHOOK'
}

/** Identifies documents */
export type UserManyWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<UserWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  picture_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  picture_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  picture_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  picture_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  picture_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  picture_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  picture_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: Maybe<Scalars['String']>;
  kind?: Maybe<UserKind>;
  /** All values that are not equal to given value. */
  kind_not?: Maybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: Maybe<Array<UserKind>>;
  /** All values that are not contained in given list. */
  kind_not_in?: Maybe<Array<UserKind>>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** All values that are not equal to given value. */
  isActive_not?: Maybe<Scalars['Boolean']>;
};

export enum UserOrderByInput {
  IdAsc = 'id_ASC',
  IdDesc = 'id_DESC',
  CreatedAtAsc = 'createdAt_ASC',
  CreatedAtDesc = 'createdAt_DESC',
  UpdatedAtAsc = 'updatedAt_ASC',
  UpdatedAtDesc = 'updatedAt_DESC',
  PublishedAtAsc = 'publishedAt_ASC',
  PublishedAtDesc = 'publishedAt_DESC',
  NameAsc = 'name_ASC',
  NameDesc = 'name_DESC',
  PictureAsc = 'picture_ASC',
  PictureDesc = 'picture_DESC',
  KindAsc = 'kind_ASC',
  KindDesc = 'kind_DESC',
  IsActiveAsc = 'isActive_ASC',
  IsActiveDesc = 'isActive_DESC'
}

/** Identifies documents */
export type UserWhereInput = {
  /** Contains search across all appropriate fields. */
  _search?: Maybe<Scalars['String']>;
  /** Logical AND on all given filters. */
  AND?: Maybe<Array<UserWhereInput>>;
  /** Logical OR on all given filters. */
  OR?: Maybe<Array<UserWhereInput>>;
  /** Logical NOT on all given filters combined by AND. */
  NOT?: Maybe<Array<UserWhereInput>>;
  id?: Maybe<Scalars['ID']>;
  /** All values that are not equal to given value. */
  id_not?: Maybe<Scalars['ID']>;
  /** All values that are contained in given list. */
  id_in?: Maybe<Array<Scalars['ID']>>;
  /** All values that are not contained in given list. */
  id_not_in?: Maybe<Array<Scalars['ID']>>;
  /** All values containing the given string. */
  id_contains?: Maybe<Scalars['ID']>;
  /** All values not containing the given string. */
  id_not_contains?: Maybe<Scalars['ID']>;
  /** All values starting with the given string. */
  id_starts_with?: Maybe<Scalars['ID']>;
  /** All values not starting with the given string. */
  id_not_starts_with?: Maybe<Scalars['ID']>;
  /** All values ending with the given string. */
  id_ends_with?: Maybe<Scalars['ID']>;
  /** All values not ending with the given string */
  id_not_ends_with?: Maybe<Scalars['ID']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  createdAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  createdAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  createdAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  createdAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  createdAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  createdAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  createdAt_gte?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  updatedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  updatedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  updatedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  updatedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  updatedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  updatedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  updatedAt_gte?: Maybe<Scalars['DateTime']>;
  publishedAt?: Maybe<Scalars['DateTime']>;
  /** All values that are not equal to given value. */
  publishedAt_not?: Maybe<Scalars['DateTime']>;
  /** All values that are contained in given list. */
  publishedAt_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values that are not contained in given list. */
  publishedAt_not_in?: Maybe<Array<Scalars['DateTime']>>;
  /** All values less than the given value. */
  publishedAt_lt?: Maybe<Scalars['DateTime']>;
  /** All values less than or equal the given value. */
  publishedAt_lte?: Maybe<Scalars['DateTime']>;
  /** All values greater than the given value. */
  publishedAt_gt?: Maybe<Scalars['DateTime']>;
  /** All values greater than or equal the given value. */
  publishedAt_gte?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  name_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  name_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  name_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  name_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  name_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  name_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  name_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  name_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  name_not_ends_with?: Maybe<Scalars['String']>;
  picture?: Maybe<Scalars['String']>;
  /** All values that are not equal to given value. */
  picture_not?: Maybe<Scalars['String']>;
  /** All values that are contained in given list. */
  picture_in?: Maybe<Array<Scalars['String']>>;
  /** All values that are not contained in given list. */
  picture_not_in?: Maybe<Array<Scalars['String']>>;
  /** All values containing the given string. */
  picture_contains?: Maybe<Scalars['String']>;
  /** All values not containing the given string. */
  picture_not_contains?: Maybe<Scalars['String']>;
  /** All values starting with the given string. */
  picture_starts_with?: Maybe<Scalars['String']>;
  /** All values not starting with the given string. */
  picture_not_starts_with?: Maybe<Scalars['String']>;
  /** All values ending with the given string. */
  picture_ends_with?: Maybe<Scalars['String']>;
  /** All values not ending with the given string */
  picture_not_ends_with?: Maybe<Scalars['String']>;
  kind?: Maybe<UserKind>;
  /** All values that are not equal to given value. */
  kind_not?: Maybe<UserKind>;
  /** All values that are contained in given list. */
  kind_in?: Maybe<Array<UserKind>>;
  /** All values that are not contained in given list. */
  kind_not_in?: Maybe<Array<UserKind>>;
  isActive?: Maybe<Scalars['Boolean']>;
  /** All values that are not equal to given value. */
  isActive_not?: Maybe<Scalars['Boolean']>;
};

/** References User record uniquely */
export type UserWhereUniqueInput = {
  id?: Maybe<Scalars['ID']>;
};

export type Version = {
  __typename?: 'Version';
  id: Scalars['ID'];
  stage: Stage;
  revision: Scalars['Int'];
  createdAt: Scalars['DateTime'];
};

export type VersionWhereInput = {
  id: Scalars['ID'];
  stage: Stage;
  revision: Scalars['Int'];
};

export enum _FilterKind {
  Search = 'search',
  And = 'AND',
  Or = 'OR',
  Not = 'NOT',
  Eq = 'eq',
  EqNot = 'eq_not',
  In = 'in',
  NotIn = 'not_in',
  Lt = 'lt',
  Lte = 'lte',
  Gt = 'gt',
  Gte = 'gte',
  Contains = 'contains',
  NotContains = 'not_contains',
  StartsWith = 'starts_with',
  NotStartsWith = 'not_starts_with',
  EndsWith = 'ends_with',
  NotEndsWith = 'not_ends_with',
  ContainsAll = 'contains_all',
  ContainsSome = 'contains_some',
  ContainsNone = 'contains_none',
  RelationalSingle = 'relational_single',
  RelationalEvery = 'relational_every',
  RelationalSome = 'relational_some',
  RelationalNone = 'relational_none'
}

export enum _MutationInputFieldKind {
  Scalar = 'scalar',
  RichText = 'richText',
  RichTextWithEmbeds = 'richTextWithEmbeds',
  Enum = 'enum',
  Relation = 'relation',
  Union = 'union',
  Virtual = 'virtual'
}

export enum _MutationKind {
  Create = 'create',
  Publish = 'publish',
  Unpublish = 'unpublish',
  Update = 'update',
  Upsert = 'upsert',
  Delete = 'delete',
  UpdateMany = 'updateMany',
  PublishMany = 'publishMany',
  UnpublishMany = 'unpublishMany',
  DeleteMany = 'deleteMany'
}

export enum _OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum _RelationInputCardinality {
  One = 'one',
  Many = 'many'
}

export enum _RelationInputKind {
  Create = 'create',
  Update = 'update'
}

export enum _RelationKind {
  Regular = 'regular',
  Union = 'union'
}

export enum _SystemDateTimeFieldVariation {
  Base = 'base',
  Localization = 'localization',
  Combined = 'combined'
}

export type GetArticleQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetArticleQuery = (
  { __typename?: 'Query' }
  & { blogPost?: Maybe<(
    { __typename?: 'BlogPost' }
    & Pick<BlogPost, 'id' | 'publishedAt' | 'createdAt' | 'slug' | 'title'>
    & { author?: Maybe<(
      { __typename?: 'Author' }
      & Pick<Author, 'name'>
      & { avatar?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )> }
    )>, coverImage?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, seoData?: Maybe<(
      { __typename?: 'SeoDataItem' }
      & Pick<SeoDataItem, 'description' | 'keywords' | 'title'>
    )>, blogparent?: Maybe<(
      { __typename?: 'BlogParent' }
      & Pick<BlogParent, 'id' | 'parentname' | 'parentslug'>
      & { blogPost: Array<(
        { __typename?: 'BlogPost' }
        & Pick<BlogPost, 'slug' | 'id' | 'title' | 'publishedAt' | 'createdAt'>
        & { thumbnail?: Maybe<(
          { __typename?: 'Asset' }
          & Pick<Asset, 'url'>
        )> }
      )> }
    )>, content: (
      { __typename?: 'RichText' }
      & Pick<RichText, 'html'>
    ) }
  )> }
);

export type GetArticleParentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetArticleParentsQuery = (
  { __typename?: 'Query' }
  & { blogParents: Array<(
    { __typename?: 'BlogParent' }
    & Pick<BlogParent, 'parentname' | 'id' | 'parentslug' | 'headline' | 'description' | 'navbarOrder'>
    & { image?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'id' | 'url'>
    )> }
  )> }
);

export type GetArticlesQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
}>;


export type GetArticlesQuery = (
  { __typename?: 'Query' }
  & { blogPosts: Array<(
    { __typename?: 'BlogPost' }
    & Pick<BlogPost, 'id' | 'slug' | 'title' | 'publishedAt' | 'createdAt'>
    & { author?: Maybe<(
      { __typename?: 'Author' }
      & Pick<Author, 'name'>
      & { avatar?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )> }
    )>, thumbnail?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, coverImage?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )> }
  )>, blogPostsConnection: (
    { __typename?: 'BlogPostConnection' }
    & { aggregate: (
      { __typename?: 'Aggregate' }
      & Pick<Aggregate, 'count'>
    ) }
  ) }
);

export type GetArticlesByParentQueryVariables = Exact<{
  first?: Maybe<Scalars['Int']>;
  skip?: Maybe<Scalars['Int']>;
  parentSlug: Scalars['String'];
}>;


export type GetArticlesByParentQuery = (
  { __typename?: 'Query' }
  & { blogParent?: Maybe<(
    { __typename?: 'BlogParent' }
    & Pick<BlogParent, 'id' | 'parentname' | 'parentslug' | 'headline' | 'description' | 'navbarOrder'>
    & { image?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'id' | 'url'>
    )>, blogPost: Array<(
      { __typename?: 'BlogPost' }
      & Pick<BlogPost, 'id' | 'slug' | 'title' | 'publishedAt' | 'createdAt'>
      & { author?: Maybe<(
        { __typename?: 'Author' }
        & Pick<Author, 'name'>
        & { avatar?: Maybe<(
          { __typename?: 'Asset' }
          & Pick<Asset, 'url'>
        )> }
      )>, thumbnail?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, coverImage?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )> }
    )> }
  )>, blogPostsConnection: (
    { __typename?: 'BlogPostConnection' }
    & { aggregate: (
      { __typename?: 'Aggregate' }
      & Pick<Aggregate, 'count'>
    ) }
  ) }
);

export type GetCityQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetCityQuery = (
  { __typename?: 'Query' }
  & { city?: Maybe<(
    { __typename?: 'City' }
    & Pick<City, 'name' | 'title1' | 'title2' | 'about' | 'id' | 'slug' | 'descriptionHeader' | 'descriptionText' | 'abaTherapyDescription' | 'autismDiagnosisDescription'>
    & { state?: Maybe<(
      { __typename?: 'State' }
      & Pick<State, 'id' | 'name' | 'code' | 'slug'>
    )>, coverImage?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, mapImage?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, leadProvider: Array<(
      { __typename?: 'Provider' }
      & Pick<Provider, 'id' | 'name' | 'slug' | 'about' | 'type' | 'telehealth'>
      & { photo?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )> }
    )>, providers: Array<(
      { __typename?: 'Provider' }
      & Pick<Provider, 'id' | 'name' | 'slug' | 'about' | 'type' | 'telehealth'>
      & { photo?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )> }
    )>, clinics: Array<(
      { __typename?: 'Clinic' }
      & Pick<Clinic, 'address' | 'address2' | 'address3' | 'title' | 'phone'>
      & { location: (
        { __typename?: 'Location' }
        & Pick<Location, 'latitude' | 'longitude'>
      ) }
    )> }
  )> }
);

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = (
  { __typename?: 'Query' }
  & { states: Array<(
    { __typename?: 'State' }
    & Pick<State, 'name' | 'slug' | 'id'>
    & { cities: Array<(
      { __typename?: 'City' }
      & Pick<City, 'name' | 'slug' | 'id'>
    )> }
  )> }
);

export type GetStateQueryVariables = Exact<{
  slug?: Maybe<Scalars['String']>;
}>;


export type GetStateQuery = (
  { __typename?: 'Query' }
  & { state?: Maybe<(
    { __typename?: 'State' }
    & Pick<State, 'id' | 'about' | 'name' | 'code' | 'slug'>
    & { coverImage?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, mapImage?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )>, cities: Array<(
      { __typename?: 'City' }
      & Pick<City, 'id' | 'slug' | 'name'>
      & { thumbnail?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, coverImage?: Maybe<(
        { __typename?: 'Asset' }
        & Pick<Asset, 'url'>
      )>, providers: Array<(
        { __typename?: 'Provider' }
        & Pick<Provider, 'id' | 'slug' | 'name' | 'type' | 'about' | 'telehealth'>
        & { photo?: Maybe<(
          { __typename?: 'Asset' }
          & Pick<Asset, 'url'>
        )> }
      )> }
    )> }
  )> }
);

export type GetTherapistsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTherapistsQuery = (
  { __typename?: 'Query' }
  & { providers: Array<(
    { __typename?: 'Provider' }
    & Pick<Provider, 'name' | 'type' | 'about' | 'id' | 'slug' | 'telehealth'>
    & { cities: Array<(
      { __typename?: 'City' }
      & Pick<City, 'id' | 'slug' | 'name'>
      & { state?: Maybe<(
        { __typename?: 'State' }
        & Pick<State, 'id' | 'slug' | 'name' | 'code'>
      )> }
    )>, photo?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )> }
  )> }
);

export type GetTherapistsByCityQueryVariables = Exact<{
  cityIds?: Maybe<Array<Scalars['ID']> | Scalars['ID']>;
}>;


export type GetTherapistsByCityQuery = (
  { __typename?: 'Query' }
  & { providers: Array<(
    { __typename?: 'Provider' }
    & Pick<Provider, 'name' | 'type' | 'about' | 'id' | 'slug' | 'telehealth'>
    & { cities: Array<(
      { __typename?: 'City' }
      & Pick<City, 'id' | 'slug' | 'name'>
      & { state?: Maybe<(
        { __typename?: 'State' }
        & Pick<State, 'id' | 'slug' | 'name' | 'code'>
      )> }
    )>, photo?: Maybe<(
      { __typename?: 'Asset' }
      & Pick<Asset, 'url'>
    )> }
  )> }
);


export const GetArticleDocument = gql`
    query GetArticle($slug: String) {
  blogPost(where: {slug: $slug}) {
    author {
      avatar {
        url
      }
      name
    }
    coverImage {
      url
    }
    id
    publishedAt
    createdAt
    seoData {
      description
      keywords
      title
    }
    slug
    title
    blogparent {
      id
      parentname
      parentslug
      blogPost {
        slug
        id
        title
        publishedAt
        createdAt
        thumbnail {
          url
        }
      }
    }
    content {
      html
    }
  }
}
    `;
export const GetArticleParentsDocument = gql`
    query GetArticleParents {
  blogParents {
    parentname
    id
    parentslug
    headline
    description
    navbarOrder
    image {
      id
      url
    }
  }
}
    `;
export const GetArticlesDocument = gql`
    query GetArticles($first: Int, $skip: Int) {
  blogPosts(first: $first, skip: $skip, orderBy: publishedAt_DESC) {
    id
    slug
    title
    author {
      name
      avatar {
        url
      }
    }
    thumbnail {
      url
    }
    coverImage {
      url
    }
    publishedAt
    createdAt
  }
  blogPostsConnection {
    aggregate {
      count
    }
  }
}
    `;
export const GetArticlesByParentDocument = gql`
    query GetArticlesByParent($first: Int, $skip: Int, $parentSlug: String!) {
  blogParent(where: {parentslug: $parentSlug}) {
    id
    parentname
    parentslug
    headline
    description
    navbarOrder
    image {
      id
      url
    }
    blogPost(first: $first, skip: $skip, orderBy: publishedAt_DESC) {
      id
      slug
      title
      author {
        name
        avatar {
          url
        }
      }
      thumbnail {
        url
      }
      coverImage {
        url
      }
      publishedAt
      createdAt
    }
  }
  blogPostsConnection(where: {blogparent: {parentslug: $parentSlug}}) {
    aggregate {
      count
    }
  }
}
    `;
export const GetCityDocument = gql`
    query GetCity($slug: String) {
  city(where: {slug: $slug}) {
    name
    title1
    title2
    about
    id
    slug
    descriptionHeader
    descriptionText
    abaTherapyDescription
    autismDiagnosisDescription
    state {
      id
      name
      code
      slug
    }
    coverImage {
      url
    }
    mapImage {
      url
    }
    leadProvider {
      id
      name
      slug
      about
      type
      telehealth
      photo {
        url
      }
    }
    providers {
      id
      name
      slug
      about
      type
      telehealth
      photo {
        url
      }
    }
    clinics {
      address
      address2
      address3
      location {
        latitude
        longitude
      }
      title
      phone
    }
  }
}
    `;
export const GetLocationsDocument = gql`
    query GetLocations {
  states {
    name
    slug
    id
    cities {
      name
      slug
      id
    }
  }
}
    `;
export const GetStateDocument = gql`
    query GetState($slug: String) {
  state(where: {slug: $slug}) {
    id
    about
    name
    code
    slug
    coverImage {
      url
    }
    mapImage {
      url
    }
    cities {
      id
      slug
      name
      thumbnail {
        url
      }
      coverImage {
        url
      }
      providers {
        id
        slug
        name
        type
        about
        telehealth
        photo {
          url
        }
      }
    }
  }
}
    `;
export const GetTherapistsDocument = gql`
    query GetTherapists {
  providers {
    name
    type
    about
    id
    slug
    telehealth
    cities {
      id
      slug
      name
      state {
        id
        slug
        name
        code
      }
    }
    photo {
      url
    }
  }
}
    `;
export const GetTherapistsByCityDocument = gql`
    query GetTherapistsByCity($cityIds: [ID!]) {
  providers(where: {cities_some: {id_in: $cityIds}}) {
    name
    type
    about
    id
    slug
    telehealth
    cities {
      id
      slug
      name
      state {
        id
        slug
        name
        code
      }
    }
    photo {
      url
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: () => Promise<T>) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = sdkFunction => sdkFunction();
export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    GetArticle(variables?: GetArticleQueryVariables, requestHeaders?: Headers): Promise<GetArticleQuery> {
      return withWrapper(() => client.request<GetArticleQuery>(print(GetArticleDocument), variables, requestHeaders));
    },
    GetArticleParents(variables?: GetArticleParentsQueryVariables, requestHeaders?: Headers): Promise<GetArticleParentsQuery> {
      return withWrapper(() => client.request<GetArticleParentsQuery>(print(GetArticleParentsDocument), variables, requestHeaders));
    },
    GetArticles(variables?: GetArticlesQueryVariables, requestHeaders?: Headers): Promise<GetArticlesQuery> {
      return withWrapper(() => client.request<GetArticlesQuery>(print(GetArticlesDocument), variables, requestHeaders));
    },
    GetArticlesByParent(variables: GetArticlesByParentQueryVariables, requestHeaders?: Headers): Promise<GetArticlesByParentQuery> {
      return withWrapper(() => client.request<GetArticlesByParentQuery>(print(GetArticlesByParentDocument), variables, requestHeaders));
    },
    GetCity(variables?: GetCityQueryVariables, requestHeaders?: Headers): Promise<GetCityQuery> {
      return withWrapper(() => client.request<GetCityQuery>(print(GetCityDocument), variables, requestHeaders));
    },
    GetLocations(variables?: GetLocationsQueryVariables, requestHeaders?: Headers): Promise<GetLocationsQuery> {
      return withWrapper(() => client.request<GetLocationsQuery>(print(GetLocationsDocument), variables, requestHeaders));
    },
    GetState(variables?: GetStateQueryVariables, requestHeaders?: Headers): Promise<GetStateQuery> {
      return withWrapper(() => client.request<GetStateQuery>(print(GetStateDocument), variables, requestHeaders));
    },
    GetTherapists(variables?: GetTherapistsQueryVariables, requestHeaders?: Headers): Promise<GetTherapistsQuery> {
      return withWrapper(() => client.request<GetTherapistsQuery>(print(GetTherapistsDocument), variables, requestHeaders));
    },
    GetTherapistsByCity(variables?: GetTherapistsByCityQueryVariables, requestHeaders?: Headers): Promise<GetTherapistsByCityQuery> {
      return withWrapper(() => client.request<GetTherapistsByCityQuery>(print(GetTherapistsByCityDocument), variables, requestHeaders));
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;